import * as i0 from '@angular/core';
import { Injectable, Component, EventEmitter, HostListener, Output, Directive, Input, ViewEncapsulation, NgModule } from '@angular/core';
import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$3 from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import * as i2$1 from '@angular/material/menu';
import { MatMenuModule } from '@angular/material/menu';
import * as i2 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i1 from '@fortawesome/angular-fontawesome';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { far } from '@fortawesome/free-regular-svg-icons';
import { faAnglesLeft, faAnglesRight, fas } from '@fortawesome/free-solid-svg-icons';
import * as i1$2 from '@angular/router';
const _c0 = ["*"];
const _c1 = (a0, a1) => [a0, a1];
function Button_su_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "su-icon", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", ctx_r0.icon);
  }
}
function Button_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label);
  }
}
function Button_su_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "su-icon", 5);
  }
}
const _c2 = a0 => ({
  clickable: a0
});
function Breadcrumbs_ng_container_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 8);
    i0.ɵɵelement(2, "su-icon", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 10);
    i0.ɵɵlistener("click", function Breadcrumbs_ng_container_7_ng_container_1_Template_div_click_3_listener($event) {
      const slotItem_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      return i0.ɵɵresetView(slotItem_r2.onClick ? slotItem_r2.onClick($event) : null);
    });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const slotItem_r2 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c2, slotItem_r2.onClick));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", slotItem_r2.label, " ");
  }
}
function Breadcrumbs_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, Breadcrumbs_ng_container_7_ng_container_1_Template, 5, 4, "ng-container", 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.slots);
  }
}
const _c3 = [[["", "card-content", ""]], [["", "slot-modal-1", ""]], [["", "slot-modal-2", ""]]];
const _c4 = ["[card-content]", "[slot-modal-1]", "[slot-modal-2]"];
const _c5 = a0 => ({
  "with-border": a0
});
function ContentCard_div_1_su_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "su-icon", 11);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("icon", ctx_r0.card.header.title.icon);
  }
}
function ContentCard_div_1_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 12);
    i0.ɵɵelement(2, "su-icon", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-menu", 13, 0);
    i0.ɵɵprojection(5, 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const slot1_r2 = i0.ɵɵreference(4);
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("matMenuTriggerFor", slot1_r2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", ctx_r0.card.header.slot1.icon);
  }
}
function ContentCard_div_1_ng_container_6_button_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵelement(1, "su-icon", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const slot2_r3 = i0.ɵɵreference(3);
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("matMenuTriggerFor", slot2_r3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", ctx_r0.card.header.slot2.icon);
  }
}
function ContentCard_div_1_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ContentCard_div_1_ng_container_6_button_1_Template, 2, 2, "button", 14);
    i0.ɵɵelementStart(2, "mat-menu", 13, 1);
    i0.ɵɵprojection(4, 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.card.header.slot2);
  }
}
function ContentCard_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7);
    i0.ɵɵtemplate(2, ContentCard_div_1_su_icon_2_Template, 1, 1, "su-icon", 8);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 9);
    i0.ɵɵtemplate(5, ContentCard_div_1_ng_container_5_Template, 6, 2, "ng-container", 10)(6, ContentCard_div_1_ng_container_6_Template, 5, 1, "ng-container", 10);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c5, ctx_r0.card.header.title.withBorder));
    i0.ɵɵattribute("aria-level", ctx_r0.headerLevel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.card.header.title.icon);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.card.header.title.label, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.card.header.slot1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.card.header.slot2);
  }
}
function ContentCard_div_4_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19)(1, "su-button", 20);
    i0.ɵɵlistener("onClick", function ContentCard_div_4_div_1_Template_su_button_onClick_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.card.footer.button3.onClick($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("asLink", ctx_r0.card.footer.button3.asLink)("disabled", ctx_r0.card.footer.button3.disabled)("label", ctx_r0.card.footer.button3.label)("type", ctx_r0.card.footer.button3.type)("tooltip", ctx_r0.card.footer.button3.tooltip ? ctx_r0.card.footer.button3.tooltip : null)("ariaLabel", ctx_r0.card.footer.button3.label + ", " + ctx_r0.card.footer.button3.tooltip);
  }
}
function ContentCard_div_4_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21)(1, "su-button", 20);
    i0.ɵɵlistener("onClick", function ContentCard_div_4_div_2_Template_su_button_onClick_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.card.footer.button2.onClick($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("asLink", ctx_r0.card.footer.button2.asLink)("disabled", ctx_r0.card.footer.button2.disabled)("label", ctx_r0.card.footer.button2.label)("type", ctx_r0.card.footer.button2.type)("tooltip", ctx_r0.card.footer.button2.tooltip ? ctx_r0.card.footer.button2.tooltip : null)("ariaLabel", ctx_r0.card.footer.button2.label + ", " + ctx_r0.card.footer.button2.tooltip);
  }
}
function ContentCard_div_4_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "su-button", 23);
    i0.ɵɵlistener("onClick", function ContentCard_div_4_div_3_Template_su_button_onClick_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.card.footer.button1.onClick($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("asLink", ctx_r0.card.footer.button1.asLink)("disabled", ctx_r0.card.footer.button1.disabled)("label", ctx_r0.card.footer.button1.label)("hidden", ctx_r0.card.footer.button1.hide)("type", ctx_r0.card.footer.button1.type)("tooltip", ctx_r0.card.footer.button1.tooltip ? ctx_r0.card.footer.button1.tooltip : null)("ariaLabel", ctx_r0.card.footer.button1.label + ", " + ctx_r0.card.footer.button1.tooltip);
  }
}
function ContentCard_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, ContentCard_div_4_div_1_Template, 2, 6, "div", 16)(2, ContentCard_div_4_div_2_Template, 2, 6, "div", 17)(3, ContentCard_div_4_div_3_Template, 2, 7, "div", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.card.footer.button3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.card.footer.button2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.card.footer.button1);
  }
}
function Chips_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 3);
    i0.ɵɵlistener("click", function Chips_div_1_Template_button_click_3_listener() {
      const chipItem_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onRemoveCallback(chipItem_r2));
    });
    i0.ɵɵelement(4, "su-icon", 4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const chipItem_r2 = ctx.$implicit;
    i0.ɵɵattribute("data-chip-id", chipItem_r2.id)("aria-label", chipItem_r2.label);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(chipItem_r2.label);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", chipItem_r2.label + " entfernen");
  }
}
function Headline_h1_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 4);
    i0.ɵɵelementContainer(1, 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const headlineRef_r2 = i0.ɵɵreference(7);
    i0.ɵɵproperty("ngClass", ctx_r0.skin);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", headlineRef_r2);
  }
}
function Headline_h2_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 4);
    i0.ɵɵelementContainer(1, 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const headlineRef_r2 = i0.ɵɵreference(7);
    i0.ɵɵproperty("ngClass", ctx_r0.skin);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", headlineRef_r2);
  }
}
function Headline_h3_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 4);
    i0.ɵɵelementContainer(1, 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const headlineRef_r2 = i0.ɵɵreference(7);
    i0.ɵɵproperty("ngClass", ctx_r0.skin);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", headlineRef_r2);
  }
}
function Headline_h4_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h4", 4);
    i0.ɵɵelementContainer(1, 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const headlineRef_r2 = i0.ɵɵreference(7);
    i0.ɵɵproperty("ngClass", ctx_r0.skin);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", headlineRef_r2);
  }
}
function Headline_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function LinkCard_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "su-icon", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", ctx_r0.icon);
  }
}
const _c6 = a0 => ({
  "menu-extra-popup-extended": a0
});
function MenuExtra_div_2_ng_container_1_su_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "su-button", 7);
    i0.ɵɵlistener("onClick", function MenuExtra_div_2_ng_container_1_su_button_1_Template_su_button_onClick_0_listener($event) {
      const i_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      return i0.ɵɵresetView(i_r4.onClick($event, i_r4));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r4 = ctx.$implicit;
    i0.ɵɵproperty("icon", i_r4.icon)("label", i_r4.label)("disabled", i_r4.disabled);
  }
}
function MenuExtra_div_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MenuExtra_div_2_ng_container_1_su_button_1_Template, 1, 3, "su-button", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.menuItems);
  }
}
function MenuExtra_div_2_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
}
function MenuExtra_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵlistener("appOutsideClick", function MenuExtra_div_2_Template_div_appOutsideClick_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleOutsideClick($event));
    })("click", function MenuExtra_div_2_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵtemplate(1, MenuExtra_div_2_ng_container_1_Template, 2, 1, "ng-container", 4)(2, MenuExtra_div_2_div_2_Template, 2, 0, "div", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c6, !ctx_r1.menuItems || ctx_r1.menuItems.length === 0));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.menuItems && ctx_r1.menuItems.length > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.menuItems || ctx_r1.menuItems.length === 0);
  }
}
function NavSecondaryList_li_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "a", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("href", item_r1.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r1.label);
  }
}
const _c7 = a0 => ({
  isCollapsed: a0
});
const _c8 = a0 => ({
  selected: a0
});
function SideNav_ng_container_1_button_4_su_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "su-icon", 8);
  }
  if (rf & 2) {
    const navItem_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("icon", navItem_r2.icon);
  }
}
function SideNav_ng_container_1_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function SideNav_ng_container_1_button_4_Template_button_click_0_listener() {
      const navItem_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      return i0.ɵɵresetView(navItem_r2.onClick(navItem_r2.id));
    });
    i0.ɵɵtemplate(1, SideNav_ng_container_1_button_4_su_icon_1_Template, 1, 1, "su-icon", 7);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const navItem_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c8, ctx_r2.selected === navItem_r2.id));
    i0.ɵɵattribute("aria-label", navItem_r2.label)("aria-current", ctx_r2.selected === navItem_r2.id)("aria-pressed", ctx_r2.selected === navItem_r2.id);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", navItem_r2.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(navItem_r2.label);
  }
}
function SideNav_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelement(2, "div", 3);
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵtemplate(4, SideNav_ng_container_1_button_4_Template, 4, 8, "button", 5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const navBlock_r4 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("data-content", navBlock_r4.label);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", navBlock_r4.items);
  }
}
function SlotControls_ng_container_5_su_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "su-button", 7);
    i0.ɵɵlistener("onClick", function SlotControls_ng_container_5_su_button_1_Template_su_button_onClick_0_listener($event) {
      const button_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      return i0.ɵɵresetView(button_r2.onClick($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const button_r2 = ctx.$implicit;
    i0.ɵɵproperty("icon", button_r2.icon)("label", button_r2.label)("disabled", button_r2.disabled);
  }
}
function SlotControls_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SlotControls_ng_container_5_su_button_1_Template, 1, 3, "su-button", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.buttons);
  }
}
function SlotControls_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "su-menu-extra", 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("menuItems", ctx_r2.menuItems);
  }
}
function SlotDialogFooter_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "su-button", 2);
    i0.ɵɵlistener("onClick", function SlotDialogFooter_ng_container_1_Template_su_button_onClick_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.footer.button3.onClick($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("label", ctx_r1.footer.button3.label)("disabled", ctx_r1.footer.button3.disabled);
  }
}
function SlotDialogFooter_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "su-button", 2);
    i0.ɵɵlistener("onClick", function SlotDialogFooter_ng_container_2_Template_su_button_onClick_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.footer.button2.onClick($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("label", ctx_r1.footer.button2.label)("disabled", ctx_r1.footer.button2.disabled);
  }
}
function SlotDialogFooter_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "su-button", 3);
    i0.ɵɵlistener("onClick", function SlotDialogFooter_ng_container_3_Template_su_button_onClick_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.footer.button1.onClick($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("label", ctx_r1.footer.button1.label)("disabled", ctx_r1.footer.button1.disabled);
  }
}
const _c9 = (a0, a1) => ({
  hasSideNav: a0,
  isSideNavOpen: a1
});
const _c10 = () => [];
function SlotMobileTopBar_su_button_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "su-button", 11);
  }
}
function SlotMobileTopBar_su_menu_extra_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "su-menu-extra", 12);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("menuItems", ctx_r0.accountBtns);
  }
}
function SlotMobileTopBar_su_button_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "su-button", 13);
    i0.ɵɵlistener("onClick", function SlotMobileTopBar_su_button_11_Template_su_button_onClick_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.handleToggleClick());
    });
    i0.ɵɵelementEnd();
  }
}
function SlotMobileTopBar_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15);
    i0.ɵɵelement(2, "su-side-nav", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 17);
    i0.ɵɵelement(4, "su-nav-list", 18);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("nav", ctx_r0.navItemsTree || i0.ɵɵpureFunction0(4, _c10))("selected", ctx_r0.activeNavItem)("isOpen", ctx_r0.isOpen);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("nav", ctx_r0.metaNavItemsTree || i0.ɵɵpureFunction0(5, _c10));
  }
}
function SlotMobileTopBar_div_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵlistener("click", function SlotMobileTopBar_div_13_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.handleToggleClick());
    });
    i0.ɵɵelementEnd();
  }
}
function SlotShortcuts_su_headline_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "su-headline", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.heading);
  }
}
function SlotShortcuts_div_2_su_block_link_cards_1_su_link_card_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "su-link-card", 8);
    i0.ɵɵlistener("onClick", function SlotShortcuts_div_2_su_block_link_cards_1_su_link_card_1_Template_su_link_card_onClick_0_listener() {
      const link_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      return i0.ɵɵresetView(link_r3.onClick());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r3 = ctx.$implicit;
    i0.ɵɵproperty("label", link_r3.label)("icon", link_r3.icon);
    i0.ɵɵattribute("title", link_r3.tooltip ? link_r3.tooltip : null);
  }
}
function SlotShortcuts_div_2_su_block_link_cards_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "su-block-link-cards", 6);
    i0.ɵɵtemplate(1, SlotShortcuts_div_2_su_block_link_cards_1_su_link_card_1_Template, 1, 3, "su-link-card", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = ctx.$implicit;
    i0.ɵɵproperty("label", item_r4.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", item_r4.items);
  }
}
function SlotShortcuts_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, SlotShortcuts_div_2_su_block_link_cards_1_Template, 2, 2, "su-block-link-cards", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.links);
  }
}
function SlotShortcuts_div_3_su_card_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const card_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", card_r5.text, " ");
  }
}
function SlotShortcuts_div_3_su_card_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "su-card", 10);
    i0.ɵɵtemplate(1, SlotShortcuts_div_3_su_card_1_div_1_Template, 2, 1, "div", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const card_r5 = ctx.$implicit;
    i0.ɵɵproperty("card", card_r5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", card_r5.text);
  }
}
function SlotShortcuts_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, SlotShortcuts_div_3_su_card_1_Template, 2, 2, "su-card", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.cards);
  }
}
const _c11 = a0 => ({
  isOpen: a0
});
function SlotSideNav_div_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵlistener("click", function SlotSideNav_div_10_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleToggleClick());
    });
    i0.ɵɵelementEnd();
  }
}
const _c12 = a0 => ({
  "slot-tab-content-slide-in": a0
});
function Tabs_ng_container_1_su_icon_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "su-icon", 5);
  }
  if (rf & 2) {
    const tab_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵstyleProp("color", tab_r2.iconColor);
    i0.ɵɵproperty("icon", tab_r2.icon);
  }
}
function Tabs_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 2);
    i0.ɵɵelementStart(1, "div")(2, "button", 3);
    i0.ɵɵlistener("click", function Tabs_ng_container_1_Template_button_click_2_listener() {
      const tab_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      return i0.ɵɵresetView(tab_r2.onClick(tab_r2.id));
    });
    i0.ɵɵtext(3);
    i0.ɵɵtemplate(4, Tabs_ng_container_1_su_icon_4_Template, 1, 3, "su-icon", 4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const tab_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", tab_r2.disabled)("ngClass", i0.ɵɵpureFunction1(8, _c8, ctx_r2.activeTab === tab_r2.id));
    i0.ɵɵattribute("aria-label", tab_r2.label)("aria-pressed", ctx_r2.activeTab === tab_r2.id)("aria-selected", ctx_r2.activeTab === tab_r2.id)("title", tab_r2.tooltip ? tab_r2.tooltip : null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", tab_r2.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", tab_r2.icon);
  }
}
function SlotTopBar_su_breadcrumbs_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "su-breadcrumbs", 14);
    i0.ɵɵlistener("onBackBtnClick", function SlotTopBar_su_breadcrumbs_2_Template_su_breadcrumbs_onBackBtnClick_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleBackBtnClick());
    })("onHomeBtnClick", function SlotTopBar_su_breadcrumbs_2_Template_su_breadcrumbs_onHomeBtnClick_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleHomeBtnClick());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("slots", ctx_r1.breadcrumbs);
  }
}
function SlotTopBar_su_button_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "su-button", 15);
    i0.ɵɵlistener("onClick", function SlotTopBar_su_button_6_Template_su_button_onClick_0_listener() {
      const btn_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      return i0.ɵɵresetView(btn_r4.onClick(btn_r4.id));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const btn_r4 = ctx.$implicit;
    i0.ɵɵproperty("label", btn_r4.label)("icon", btn_r4.icon)("disabled", btn_r4.disabled);
  }
}
function SlotTopBar_su_button_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "su-button", 16);
    i0.ɵɵlistener("onClick", function SlotTopBar_su_button_11_Template_su_button_onClick_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleLoginClick());
    });
    i0.ɵɵelementEnd();
  }
}
function SlotTopBar_su_menu_extra_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "su-menu-extra", 17);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("label", ctx_r1.userInfo)("menuItems", ctx_r1.accountBtns);
  }
}
function SlotTopBar_su_button_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "su-button", 18);
    i0.ɵɵlistener("onClick", function SlotTopBar_su_button_14_Template_su_button_onClick_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleLoginClick());
    });
    i0.ɵɵelementEnd();
  }
}
function SlotTopBar_su_menu_extra_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "su-menu-extra", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("menuItems", ctx_r1.accountBtns);
  }
}
let SmartusComponentsService = /*#__PURE__*/(() => {
  class SmartusComponentsService {
    constructor() {}
    static ɵfac = function SmartusComponentsService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SmartusComponentsService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SmartusComponentsService,
      factory: SmartusComponentsService.ɵfac,
      providedIn: 'root'
    });
  }
  return SmartusComponentsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SmartusComponentsComponent = /*#__PURE__*/(() => {
  class SmartusComponentsComponent {
    constructor() {}
    ngOnInit() {}
    static ɵfac = function SmartusComponentsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SmartusComponentsComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SmartusComponentsComponent,
      selectors: [["lib-smartus-components"]],
      standalone: false,
      decls: 2,
      vars: 0,
      template: function SmartusComponentsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "p");
          i0.ɵɵtext(1, "smartus-components works!");
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2
    });
  }
  return SmartusComponentsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OutsideClickDirective = /*#__PURE__*/(() => {
  class OutsideClickDirective {
    _elementRef;
    appOutsideClick = new EventEmitter();
    constructor(_elementRef) {
      this._elementRef = _elementRef;
    }
    onClick(targetElement) {
      const clickedInside = this._elementRef.nativeElement.contains(targetElement);
      if (!clickedInside) {
        this.appOutsideClick.emit(true);
      } else {
        this.appOutsideClick.emit(false);
      }
    }
    static ɵfac = function OutsideClickDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OutsideClickDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: OutsideClickDirective,
      selectors: [["", "appOutsideClick", ""]],
      hostBindings: function OutsideClickDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function OutsideClickDirective_click_HostBindingHandler($event) {
            return ctx.onClick($event.target);
          }, false, i0.ɵɵresolveDocument);
        }
      },
      outputs: {
        appOutsideClick: "appOutsideClick"
      },
      standalone: false
    });
  }
  return OutsideClickDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Indicator element of the current page. Allows to visualize the segments of the current route and to navigate to the home page and back.
 *
 * */
let BlockLinkCards = /*#__PURE__*/(() => {
  class BlockLinkCards {
    label = '';
    static ɵfac = function BlockLinkCards_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BlockLinkCards)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BlockLinkCards,
      selectors: [["su-block-link-cards"]],
      inputs: {
        label: "label"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 5,
      vars: 1,
      consts: [["data-ui", "block-link-cards", 1, "block-link-cards"], [1, "label"], [1, "cards-wrapper"]],
      template: function BlockLinkCards_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
          i0.ɵɵtext(2);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "div", 2);
          i0.ɵɵprojection(4);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.label);
        }
      },
      styles: [".block-link-cards[_ngcontent-%COMP%]{position:relative;width:100%;max-width:840px;background:#fff;border:1px solid #ededed;border-radius:15px;padding:15px;margin-top:30px}.block-link-cards[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{position:absolute;height:24px;left:20px;top:-12px;font-weight:700;font-size:var(--fs-bl);line-height:1.5;color:#262626;background-color:#fff;padding:0 15px}.block-link-cards[_ngcontent-%COMP%]   .cards-wrapper[_ngcontent-%COMP%]{display:flex;gap:15px;flex-wrap:wrap;margin-top:15px}"]
    });
  }
  return BlockLinkCards;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * List of available icons: https://fontawesome.com/search?m=free&o=r|FontAwesome
 *
 * ## Some examples:
 */
/**
 * Component
 * @property {string} icon - icon name
 * @property {string} [size] - icon size-scale
 * @property {string} [prefix] - icon collection reference
 */
let Icon = /*#__PURE__*/(() => {
  class Icon {
    /**
     * icon name (string)
     */
    icon = 'plus';
    /**
     * Resize the icon based in the parent font-size.
     * Sizing Icons doc in {@link https://fontawesome.com/docs/web/style/size|FontAwesome Docs}
     * Default: same parent font-sie (1x)
     */
    size = '1x';
    /**
     * Installed: "fas" (default), "far"
     */
    prefix = 'fas';
    static ɵfac = function Icon_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || Icon)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: Icon,
      selectors: [["su-icon"]],
      inputs: {
        icon: "icon",
        size: "size",
        prefix: "prefix"
      },
      standalone: false,
      decls: 2,
      vars: 5,
      consts: [[1, "icon"], [3, "icon", "size"]],
      template: function Icon_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "i", 0);
          i0.ɵɵelement(1, "fa-icon", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("icon", i0.ɵɵpureFunction2(2, _c1, ctx.prefix, ctx.icon))("size", ctx.size);
        }
      },
      dependencies: [i1.FaIconComponent],
      styles: [".icon[_ngcontent-%COMP%]{color:inherit}"]
    });
  }
  return Icon;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Call To action element.
 * */
let Button = /*#__PURE__*/(() => {
  class Button {
    onClick = new EventEmitter();
    label = '';
    /**
     * icon: List of free icons in {@link https://fontawesome.com/search?m=free&o=r|FontAwesome Icons}
     */
    icon;
    /** skin: The appearance is configurable by setting the "skin" property:
     *  - 'primary'
     *  - 'accent'
     *  - 'secondary'
     *  - 'tertiary'
     * */
    skin = 'primary';
    /** Aria-label: use just in buttons without text "label" (just icon)
     * */
    ariaLabel = '';
    disabled = false;
    /**
     * asLink: This property displays the button with link appearance
     * */
    asLink = false;
    type = 'button';
    tooltip = '';
    /**
     * @ignore
     */
    onClickCallback(event) {
      if (!this.disabled) {
        this.onClick.emit(event);
      } else {
        event.stopPropagation();
      }
    }
    static ɵfac = function Button_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || Button)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: Button,
      selectors: [["su-button"]],
      inputs: {
        label: "label",
        icon: "icon",
        skin: "skin",
        ariaLabel: "ariaLabel",
        disabled: "disabled",
        asLink: "asLink",
        type: "type",
        tooltip: "tooltip"
      },
      outputs: {
        onClick: "onClick"
      },
      standalone: false,
      decls: 4,
      vars: 11,
      consts: [["data-ui", "button", 1, "su-button", 3, "click", "ngClass", "disabled", "type", "matTooltip"], [3, "icon", 4, "ngIf"], [4, "ngIf"], ["icon", "arrow-right", 4, "ngIf"], [3, "icon"], ["icon", "arrow-right"]],
      template: function Button_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "button", 0);
          i0.ɵɵlistener("click", function Button_Template_button_click_0_listener($event) {
            return ctx.onClickCallback($event);
          });
          i0.ɵɵtemplate(1, Button_su_icon_1_Template, 1, 1, "su-icon", 1)(2, Button_span_2_Template, 2, 1, "span", 2)(3, Button_su_icon_3_Template, 1, 0, "su-icon", 3);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c1, ctx.skin, ctx.asLink ? "as-link" : ""))("disabled", ctx.disabled)("type", ctx.type)("matTooltip", ctx.tooltip);
          i0.ɵɵattribute("aria-label", ctx.ariaLabel);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.icon);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.label);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.asLink);
        }
      },
      dependencies: [i1$1.NgClass, i1$1.NgIf, i2.MatTooltip, Icon],
      styles: [".su-button[_ngcontent-%COMP%]{display:flex;justify-content:center;gap:5px;min-width:25px;padding:2px 20px!important;border:none;border-radius:30px!important;background-color:var(--theme-primary-500);color:#fff;font-weight:400;font-size:var(--fs-bl);line-height:2.5;letter-spacing:.05em;text-align:left;cursor:pointer;transition:transform .15s ease-out,background-color .3s ease-out,box-shadow .3s ease-out;width:auto;white-space:normal;word-break:break-word}.su-button[_ngcontent-%COMP%]:hover{background-color:color-mix(in srgb,var(--theme-primary-500) 90%,black);text-decoration:underline}.su-button[_ngcontent-%COMP%]:focus-visible{box-shadow:0 0 0 2px #000;outline:none;text-decoration:underline}.su-button[_ngcontent-%COMP%]:hover:not(:disabled), .su-button[_ngcontent-%COMP%]:hover:not([disabled]), .su-button[_ngcontent-%COMP%]:focus-visible:not(:disabled), .su-button[_ngcontent-%COMP%]:focus-visible:not([disabled]){transform:scale(1.02)}.su-button[_ngcontent-%COMP%]:disabled, .su-button[disabled][_ngcontent-%COMP%]{background-color:#ccc;color:#666;cursor:default}.su-button[_ngcontent-%COMP%]:disabled:hover, .su-button[_ngcontent-%COMP%]:disabled:focus-visible, .su-button[disabled][_ngcontent-%COMP%]:hover, .su-button[disabled][_ngcontent-%COMP%]:focus-visible{text-decoration:none;box-shadow:none}.su-button.accent[_ngcontent-%COMP%]{background-color:var(--theme-accent-500)}.su-button.accent[_ngcontent-%COMP%]:hover{background-color:color-mix(in srgb,var(--theme-accent-500) 90%,black)}.su-button.accent[_ngcontent-%COMP%]:disabled, .su-button.accent[disabled][_ngcontent-%COMP%]{background-color:#ccc;color:#666;cursor:default}.su-button.accept[_ngcontent-%COMP%]{background-color:var(--theme-success)}.su-button.accept[_ngcontent-%COMP%]:hover{background-color:color-mix(in srgb,var(--theme-success) 90%,black)}.su-button.accept[_ngcontent-%COMP%]:disabled, .su-button.accept[disabled][_ngcontent-%COMP%]{background-color:#ccc;color:#666;cursor:default}.su-button.warn[_ngcontent-%COMP%]{background-color:var(--theme-warn)}.su-button.warn[_ngcontent-%COMP%]:hover{color:var(--theme-warn);background-color:color-mix(in srgb,var(--theme-warn) 90%,black)}.su-button.warn[_ngcontent-%COMP%]:disabled, .su-button.warn[disabled][_ngcontent-%COMP%]{background-color:#ccc;color:#666;cursor:default}.su-button.secondary[_ngcontent-%COMP%]{background-color:#fff;color:#000;border:1px solid #bfbfbf}.su-button.secondary[_ngcontent-%COMP%]:hover:not(:disabled), .su-button.secondary[_ngcontent-%COMP%]:hover:not([disabled]){background-color:color-mix(in srgb,white 90%,black)}.su-button.secondary[_ngcontent-%COMP%]:disabled, .su-button.secondary[disabled][_ngcontent-%COMP%]{color:#a1a1a1;cursor:default}.su-button.as-link[_ngcontent-%COMP%]{background-color:transparent;font-weight:700;border:none}.su-button.as-link.primary[_ngcontent-%COMP%]{color:var(--theme-primary-500)}.su-button.as-link.secondary[_ngcontent-%COMP%]{color:#000}.su-button.as-link.accent[_ngcontent-%COMP%]{color:var(--theme-accent-500)}.su-button.as-link[_ngcontent-%COMP%]:hover, .su-button.as-link[_ngcontent-%COMP%]:focus-visible{text-decoration:underline}.su-button.tertiary[_ngcontent-%COMP%]{display:flex;align-items:flex-start;border:none;color:var(--theme-accent-500);background-color:transparent;height:auto;padding:0;cursor:pointer;font-size:12px;line-height:12px}.su-button.tertiary[_ngcontent-%COMP%]:hover{color:var(--theme-primary-500);text-decoration:underline}.su-button.tertiary[_ngcontent-%COMP%]:hover:focus-visible{box-shadow:0 0 0 2px var(--theme-primary-500)}.su-button.tertiary[_ngcontent-%COMP%]:focus-visible{box-shadow:0 0 0 2px var(--theme-accent-500);outline:none;text-decoration:underline}.su-button.tertiary[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{margin-left:7px;font-weight:500;font-size:14px;line-height:16px}.su-button.tertiary[_ngcontent-%COMP%]:disabled, .su-button.tertiary[disabled][_ngcontent-%COMP%]{color:#a1a1a1;cursor:default}.su-button.tertiary[_ngcontent-%COMP%]:disabled:hover, .su-button.tertiary[_ngcontent-%COMP%]:disabled:focus-visible, .su-button.tertiary[disabled][_ngcontent-%COMP%]:hover, .su-button.tertiary[disabled][_ngcontent-%COMP%]:focus-visible{border:transparent;box-shadow:none;text-decoration:none}"]
    });
  }
  return Button;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Container component for the link elements 'su-link-card'
 *
 * */
let Breadcrumbs = /*#__PURE__*/(() => {
  class Breadcrumbs {
    router;
    slots = [];
    onBackBtnClick = new EventEmitter();
    onHomeBtnClick = new EventEmitter();
    constructor(router) {
      this.router = router;
    }
    handleBackBtnClick() {
      this.onBackBtnClick.emit();
    }
    handleHomeBtnClick() {
      this.router.navigate(['/dashboard']);
    }
    static ɵfac = function Breadcrumbs_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || Breadcrumbs)(i0.ɵɵdirectiveInject(i1$2.Router));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: Breadcrumbs,
      selectors: [["su-breadcrumbs"]],
      inputs: {
        slots: "slots"
      },
      outputs: {
        onBackBtnClick: "onBackBtnClick",
        onHomeBtnClick: "onHomeBtnClick"
      },
      standalone: false,
      decls: 8,
      vars: 1,
      consts: [["data-ui", "breadcrumbs", 1, "breadcrumbs"], [1, "slot-button-back"], ["ariaLabel", "Zur\xFCck", "skin", "tertiary", "icon", "chevron-left", 3, "onClick"], [1, "slot-pipe"], [1, "slot-button-home"], ["ariaLabel", "Zur Startseite", "skin", "tertiary", "icon", "house", 3, "onClick"], [4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "slot-separator"], ["icon", "chevron-right"], [1, "slot-label", 3, "click", "ngClass"]],
      template: function Breadcrumbs_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "su-button", 2);
          i0.ɵɵlistener("onClick", function Breadcrumbs_Template_su_button_onClick_2_listener() {
            return ctx.handleBackBtnClick();
          });
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(3, "div", 3);
          i0.ɵɵtext(4, "|");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "div", 4)(6, "su-button", 5);
          i0.ɵɵlistener("onClick", function Breadcrumbs_Template_su_button_onClick_6_listener() {
            return ctx.handleHomeBtnClick();
          });
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(7, Breadcrumbs_ng_container_7_Template, 2, 1, "ng-container", 6);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance(7);
          i0.ɵɵproperty("ngIf", ctx.slots.length > 0);
        }
      },
      dependencies: [i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf, Button, Icon],
      styles: [".breadcrumbs[_ngcontent-%COMP%]{display:flex;gap:7px;align-items:center}.breadcrumbs[_ngcontent-%COMP%]   .slot-pipe[_ngcontent-%COMP%], .breadcrumbs[_ngcontent-%COMP%]   .slot-separator[_ngcontent-%COMP%]{color:#bfbfbf;-webkit-user-select:none;user-select:none}.breadcrumbs[_ngcontent-%COMP%]   .slot-label[_ngcontent-%COMP%]{color:gray;min-width:30px;text-align:center}.breadcrumbs[_ngcontent-%COMP%]   .slot-label.clickable[_ngcontent-%COMP%]{cursor:pointer}.breadcrumbs[_ngcontent-%COMP%]   .slot-label.clickable[_ngcontent-%COMP%]:hover{text-decoration:underline}.breadcrumbs[_ngcontent-%COMP%]   .slot-label[_ngcontent-%COMP%]:last-child{color:#262626;font-weight:700}.slot-button-back[_ngcontent-%COMP%]{margin-left:-7.5px}"]
    });
  }
  return Breadcrumbs;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Button to open/close side navigation.
 * Functionality to be implemented by the parent component.
 *
 * */
let ButtonSideNavCollapse = /*#__PURE__*/(() => {
  class ButtonSideNavCollapse {
    /**
     * @ignore
     */
    faAnglesLeft = faAnglesLeft;
    /**
     * @ignore
     */
    faAnglesRight = faAnglesRight;
    isOpen;
    onClick = new EventEmitter();
    constructor() {
      this.isOpen = false;
    }
    /**
     * @ignore
     */
    onClickCallback(event) {
      this.onClick.emit(event);
    }
    static ɵfac = function ButtonSideNavCollapse_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ButtonSideNavCollapse)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ButtonSideNavCollapse,
      selectors: [["su-nav-collapse"]],
      inputs: {
        isOpen: "isOpen"
      },
      outputs: {
        onClick: "onClick"
      },
      standalone: false,
      decls: 2,
      vars: 1,
      consts: [["data-ui", "button-side-nav", "aria-label", "collapse navigation", 1, "side-nav-collapse", 3, "click"], [3, "icon"]],
      template: function ButtonSideNavCollapse_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "button", 0);
          i0.ɵɵlistener("click", function ButtonSideNavCollapse_Template_button_click_0_listener($event) {
            return ctx.onClickCallback($event);
          });
          i0.ɵɵelement(1, "fa-icon", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("icon", ctx.isOpen ? ctx.faAnglesLeft : ctx.faAnglesRight);
        }
      },
      dependencies: [i1.FaIconComponent],
      styles: ["button.side-nav-collapse[_ngcontent-%COMP%]{color:var(--theme-accent-500);background-color:transparent;outline:none;border:none;font-size:14px;cursor:pointer;padding:0}button.side-nav-collapse[_ngcontent-%COMP%]:hover{color:var(--theme-primary-500);transform:scale(1.02)}button.side-nav-collapse[_ngcontent-%COMP%]:hover:focus-visible{border-color:var(--theme-primary-500);background-color:color-mix(in srgb,var(--theme-primary-500) 5%,transparent)}button.side-nav-collapse[_ngcontent-%COMP%]:focus-visible{border:solid 2px var(--theme-accent-500);border-radius:4px;padding:4px;background-color:color-mix(in srgb,var(--theme-accent-500) 5%,transparent)}"]
    });
  }
  return ButtonSideNavCollapse;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Card.
 *
 * ## Configuration property "card"
 * - header
 *  - title: Title to display in card
 *    - label: text
 *    - icon (optional): icon name
 *    - withBorder (optional): boolean, display a circle border around the icon
 *  - slot1 (optional): button to show a modal, first position from the right
 *    - icon: Icon name to display
 *  - slot2 (optional):  button to show a modal, second position from the right
 *    - icon: Icon name to display
 * - footer (optional): object for the footer buttons configuration properties
 *  - button1:  first position from the right
 *    - label: text to display
 *    - disabled: boolean disabled state of the button
 *    - asLink (optional): boolean, display the button with link appearance
 *    - onClick: callback function
 *  - button2:  second position from the right
 *    - same properties as button1
 *  - button3:  first position from the left
 *    - same properties as button1
 *
 * ## Content Slots
 *
 * - "slot-modal-1":
 *  Html to display in the first modal
 *  `<div slot-modal-1> modal content here </div>`
 * - "slot-modal-2":
 *    Html to display in the second modal
 *  `<div slot-modal-2> modal content here </div>`
 * - "card-content":
 *  Html to display in the card main area
 *  `<div card-content> main content here </div>`
 *
 * */
let ContentCard = /*#__PURE__*/(() => {
  class ContentCard {
    card;
    headerLevel = 1;
    ngAfterViewInit() {
      setTimeout(() => {
        this.getHeaderLevel();
      }, 0);
    }
    getHeaderLevel() {
      for (let i = 2; i <= 6; i++) {
        if (!document.querySelector(`h${i}`)) {
          this.headerLevel = i;
          break;
        }
      }
    }
    static ɵfac = function ContentCard_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ContentCard)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ContentCard,
      selectors: [["su-card"]],
      inputs: {
        card: "card"
      },
      standalone: false,
      ngContentSelectors: _c4,
      decls: 5,
      vars: 2,
      consts: [["slot1", "matMenu"], ["slot2", "matMenu"], ["data-ui", "card", 1, "content-card"], ["class", "card-header", 4, "ngIf"], [1, "card-body"], ["class", "card-footer", 4, "ngIf"], [1, "card-header"], ["role", "heading", 1, "card-header-title", 3, "ngClass"], [3, "icon", 4, "ngIf"], [1, "card-header-slot"], [4, "ngIf"], [3, "icon"], ["aria-label", "More option", 1, "button-open", 3, "matMenuTriggerFor"], ["xPosition", "before", "yPosition", "below", 1, "info-modal_body"], ["class", "button-open", "aria-label", "More option", 3, "matMenuTriggerFor", 4, "ngIf"], [1, "card-footer"], ["class", "card-footer_slot-3", 4, "ngIf"], ["class", "card-footer_slot-2", 4, "ngIf"], ["class", "card-footer_slot-1", 4, "ngIf"], [1, "card-footer_slot-3"], ["skin", "secondary", 3, "onClick", "asLink", "disabled", "label", "type", "tooltip", "ariaLabel"], [1, "card-footer_slot-2"], [1, "card-footer_slot-1"], ["skin", "primary", 3, "onClick", "asLink", "disabled", "label", "hidden", "type", "tooltip", "ariaLabel"]],
      template: function ContentCard_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c3);
          i0.ɵɵelementStart(0, "div", 2);
          i0.ɵɵtemplate(1, ContentCard_div_1_Template, 7, 8, "div", 3);
          i0.ɵɵelementStart(2, "div", 4);
          i0.ɵɵprojection(3);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(4, ContentCard_div_4_Template, 4, 3, "div", 5);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.card == null ? null : ctx.card.header);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.card == null ? null : ctx.card.footer);
        }
      },
      dependencies: [i1$1.NgClass, i1$1.NgIf, i2$1.MatMenu, i2$1.MatMenuTrigger, Button, Icon],
      styles: [".content-card{width:100%;max-width:840px;background:#fafafa;border:1px solid #ededed;border-radius:15px;padding:15px;margin-bottom:15px}@media (min-width: 1023px){.content-card{min-width:840px}}.content-card ::selection{background-color:var(--theme-primary-500);color:#fff}.content-card h1,.content-card h2,.content-card h3,.content-card h4{margin-bottom:7.5px;font-weight:700}.content-card p{margin-bottom:15px}.content-card ul{list-style:square;margin-left:15px;margin-bottom:15px}.content-card strong{font-weight:700}.content-card .card-header{display:flex;justify-content:space-between;margin-bottom:15px}.content-card .card-header .card-header-title{font-weight:700;font-size:var(--fs-bl);line-height:1.5;color:#121212}.content-card .card-header .card-header-title su-icon i{margin-right:7.5px}.content-card .card-header .card-header-title.with-border su-icon i{border:1px solid #121212;height:24px;width:24px;display:inline-block;text-align:center;border-radius:15px;font-size:var(--fs-bl)}.content-card .card-header .card-header-slot{display:flex;gap:7px}.content-card .card-header .card-header-slot .button-open{border:1px solid var(--theme-accent-500);color:var(--theme-accent-500);background-color:transparent;font-size:14px;display:flex;align-items:center;justify-content:center;cursor:pointer;width:24px;height:24px;border-radius:12px}.content-card .card-body{font-size:var(--fs-bl);line-height:1.4;color:#3d4244;margin-bottom:30px}.content-card .card-body a:link,.content-card .card-body a:visited,.content-card .card-body a:active,.content-card .card-body a:hover{color:var(--theme-accent-500)}.content-card .card-body a:hover{text-decoration:none}.content-card .card-footer{display:flex;margin-top:15px;justify-content:flex-end;gap:15px;flex-direction:row}@media screen and (max-width: 767px){.content-card .card-footer{flex-direction:column}}@media screen and (max-width: 767px){.content-card .card-footer .card-footer_slot-1{order:1}.content-card .card-footer .card-footer_slot-1 button{width:100%}}@media screen and (max-width: 767px){.content-card .card-footer .card-footer_slot-2{order:2}.content-card .card-footer .card-footer_slot-2 button{width:100%}}.content-card .card-footer .card-footer_slot-3{flex:1}@media screen and (max-width: 767px){.content-card .card-footer .card-footer_slot-3{order:3}.content-card .card-footer .card-footer_slot-3 button{width:100%}}.info-modal_body{border:1px solid var(--theme-accent-500);box-shadow:none;padding:10px;font-style:normal;font-weight:400;font-size:14px;line-height:18px}.info-modal_body.mat-menu-after.mat-menu-above{border-bottom-left-radius:0}.info-modal_body.mat-menu-after.mat-menu-below{border-top-left-radius:0}.info-modal_body.mat-menu-before.mat-menu-below{border-top-right-radius:0}.info-modal_body h1,.info-modal_body h2,.info-modal_body h3,.info-modal_body h4{color:var(--theme-accent-500);margin-bottom:10px;font-style:normal;font-weight:700}.info-modal_body h1,.info-modal_body h2,.info-modal_body h3,.info-modal_body h4{font-size:18px;line-height:18px}\n"],
      encapsulation: 2
    });
  }
  return ContentCard;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Display a list of clickable labels
 *
 * */
let Chips = /*#__PURE__*/(() => {
  class Chips {
    /**
     * items: List of items to display.
     * - Props:
     *  - id (string)
     *  - label (string)
     * */
    items = [];
    /**
     * onRemove: callback method triggered by onClick in the button "x" of each element
     * */
    onRemove = new EventEmitter();
    /**
     * @ignore
     */
    onRemoveCallback(item) {
      this.onRemove.emit(item);
    }
    static ɵfac = function Chips_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || Chips)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: Chips,
      selectors: [["su-chip"]],
      inputs: {
        items: "items"
      },
      outputs: {
        onRemove: "onRemove"
      },
      standalone: false,
      decls: 2,
      vars: 1,
      consts: [["aria-label", "chips", "data-ui", "chips", 1, "chips-container"], ["data-ui", "chip", "class", "chip", 4, "ngFor", "ngForOf"], ["data-ui", "chip", 1, "chip"], ["title", "entfernen", 3, "click"], ["icon", "xmark"]],
      template: function Chips_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, Chips_div_1_Template, 5, 4, "div", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.items);
        }
      },
      dependencies: [i1$1.NgForOf, Icon],
      styles: [".chips-container[_ngcontent-%COMP%]{display:flex;width:100%;gap:7.5px;flex-wrap:wrap}.chips-container[_ngcontent-%COMP%]   .chip[_ngcontent-%COMP%]{background-color:var(--theme-accent-500);color:#fff;border-radius:15px;font-size:var(--fs-bl-m-1);padding:2px 15px;display:flex;justify-content:space-between;align-items:center}.chips-container[_ngcontent-%COMP%]   .chip[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{border:none;outline:none;color:inherit;background-color:transparent;cursor:pointer;margin-right:calc(-1 * 15px / 1.3);margin-top:2px;margin-left:7.5px}.chips-container[_ngcontent-%COMP%]   .chip[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover{background-color:#0003;border-radius:15px}"]
    });
  }
  return Chips;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Headline = /*#__PURE__*/(() => {
  class Headline {
    /** Headline Tag: default h1.
     * */
    h = 'h1';
    skin = 'default';
    static ɵfac = function Headline_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || Headline)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: Headline,
      selectors: [["su-headline"]],
      inputs: {
        h: "h",
        skin: "skin"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 8,
      vars: 5,
      consts: [["headlineRef", ""], [3, "ngSwitch"], [1, "margin-bottom"], ["class", "headline", "data-ui", "headline", 3, "ngClass", 4, "ngSwitchCase"], ["data-ui", "headline", 1, "headline", 3, "ngClass"], [3, "ngTemplateOutlet"]],
      template: function Headline_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementContainerStart(0, 1);
          i0.ɵɵelementStart(1, "div", 2);
          i0.ɵɵtemplate(2, Headline_h1_2_Template, 2, 2, "h1", 3)(3, Headline_h2_3_Template, 2, 2, "h2", 3)(4, Headline_h3_4_Template, 2, 2, "h3", 3)(5, Headline_h4_5_Template, 2, 2, "h4", 3);
          i0.ɵɵelementEnd();
          i0.ɵɵelementContainerEnd();
          i0.ɵɵtemplate(6, Headline_ng_template_6_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngSwitch", ctx.h);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngSwitchCase", "h1");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitchCase", "h2");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitchCase", "h3");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitchCase", "h4");
        }
      },
      dependencies: [i1$1.NgClass, i1$1.NgTemplateOutlet, i1$1.NgSwitch, i1$1.NgSwitchCase],
      styles: [".headline{line-height:1.2;font-size:var(--fs-bl)}.primary{color:var(--theme-primary-500);font-size:var(--fs-bl-M-2)}.secondary{color:var(--theme-accent-500)}.tertiary{font-weight:400;font-size:var(--fs-bl-M-1)}.default{color:#121212}.margin-bottom{margin-bottom:20px}.contactHeadline,.contactDescription{padding-left:10px}.telephone-link{color:#fff}@media only screen and (min-width: 769px){.telephone-link{text-decoration:none;cursor:default}}\n"],
      encapsulation: 2
    });
  }
  return Headline;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LinkCard = /*#__PURE__*/(() => {
  class LinkCard {
    label = '';
    icon = undefined;
    onClick = new EventEmitter();
    disabled = false;
    onClickCallback(event) {
      if (!this.disabled) {
        this.onClick.emit(event);
      } else {
        event.stopPropagation();
      }
    }
    static ɵfac = function LinkCard_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LinkCard)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: LinkCard,
      selectors: [["su-link-card"]],
      inputs: {
        label: "label",
        icon: "icon",
        disabled: "disabled"
      },
      outputs: {
        onClick: "onClick"
      },
      standalone: false,
      decls: 7,
      vars: 4,
      consts: [["data-ui", "link-card", 1, "link-card", 3, "click", "disabled"], ["class", "icon-wrapper", 4, "ngIf"], [1, "label-wrapper"], [1, "label"], [1, "icon"], ["icon", "arrow-right"], [1, "icon-wrapper"], [3, "icon"]],
      template: function LinkCard_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "button", 0);
          i0.ɵɵlistener("click", function LinkCard_Template_button_click_0_listener($event) {
            return ctx.onClickCallback($event);
          });
          i0.ɵɵtemplate(1, LinkCard_div_1_Template, 2, 1, "div", 1);
          i0.ɵɵelementStart(2, "div", 2)(3, "div", 3);
          i0.ɵɵtext(4);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "div", 4);
          i0.ɵɵelement(6, "su-icon", 5);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("disabled", ctx.disabled);
          i0.ɵɵattribute("aria-label", ctx.label);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.icon);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(ctx.label);
        }
      },
      dependencies: [i1$1.NgIf, Icon],
      styles: ["@media screen and (max-width: 767px){su-link-card{width:100%}}button.link-card{display:flex;border:none;border-radius:15px;background-color:var(--theme-primary-500);color:#fff;padding:15px;flex-direction:column;justify-content:flex-end;width:190.5px;height:125px;transition:transform .15s ease-out}@media screen and (max-width: 767px){button.link-card{width:100%}}button.link-card:disabled,button.link-card[disabled]{background-color:#ccc;color:#666;cursor:default}button.link-card .icon-wrapper{flex:1;display:flex;flex-direction:column;align-items:flex-start;font-size:var(--fs-bl-M-2)}button.link-card .label-wrapper{display:flex;justify-content:space-between;width:100%}button.link-card .label-wrapper .label{font-size:var(--fs-bl-M-1);font-weight:500;text-align:left;flex:1}button.link-card .label-wrapper .icon{display:flex;align-items:flex-end;width:30px;font-size:var(--fs-bl-M-1);justify-content:flex-end}button.link-card:hover{background-color:color-mix(in srgb,var(--theme-primary-500) 85%,black);cursor:pointer;transform:scale(1.03)}button.link-card:hover:focus-visible{outline-color:color-mix(in srgb,var(--theme-primary-500) 85%,black)}button.link-card:focus-visible{outline:solid 2px var(--theme-primary-500);outline-offset:5px}\n"],
      encapsulation: 2
    });
  }
  return LinkCard;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Shows a pop-up with buttons
 *
 * ## Configuration property "Menu-Items"
 * - label (string)
 * - buttonLabel (string): aria-label: for accessibility in case no label defined
 * - icon (IconName): see Icons
 * - menuItems (array): Each Items properties:
 *  - id (string)
 *  - label (string)
 *  - disabled (optional)(boolean)
 *  - icon (optional)(IconName): see Icons
 *  - onClick (method): callback method


 * */
let MenuExtra = /*#__PURE__*/(() => {
  class MenuExtra {
    menuItems = [];
    icon = 'ellipsis';
    label = '';
    buttonLabel = '';
    /**
     * @ignore
     */
    isVisible = false;
    /**
     * @ignore
     */
    isLocked = false;
    /**
     * @ignore
     */
    toggleClick() {
      this.isVisible = !this.isVisible;
      this.isLocked = !this.isLocked;
      setTimeout(() => {
        this.isLocked = false;
      }, 0);
    }
    /**
     * @ignore
     */
    handleOutsideClick(event) {
      if (event && !this.isLocked) {
        this.isVisible = false;
        this.isLocked = false;
      }
    }
    static ɵfac = function MenuExtra_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MenuExtra)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MenuExtra,
      selectors: [["su-menu-extra"]],
      inputs: {
        menuItems: "menuItems",
        icon: "icon",
        label: "label",
        buttonLabel: "buttonLabel"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 3,
      vars: 4,
      consts: [["data-ui", "menu-extra", 1, "menu-extra-wrapper"], ["skin", "tertiary", 3, "click", "ariaLabel", "label", "icon"], ["class", "menu-extra-popup", "data-ui", "menu-extra-popup", 3, "ngClass", "appOutsideClick", "click", 4, "ngIf"], ["data-ui", "menu-extra-popup", 1, "menu-extra-popup", 3, "appOutsideClick", "click", "ngClass"], [4, "ngIf"], ["class", "menu-extra-content", 4, "ngIf"], ["skin", "tertiary", 3, "icon", "label", "disabled", "onClick", 4, "ngFor", "ngForOf"], ["skin", "tertiary", 3, "onClick", "icon", "label", "disabled"], [1, "menu-extra-content"]],
      template: function MenuExtra_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0)(1, "su-button", 1);
          i0.ɵɵlistener("click", function MenuExtra_Template_su_button_click_1_listener() {
            return ctx.toggleClick();
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(2, MenuExtra_div_2_Template, 3, 5, "div", 2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ariaLabel", ctx.buttonLabel)("label", ctx.label)("icon", ctx.icon);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.isVisible);
        }
      },
      dependencies: [i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf, Button, OutsideClickDirective],
      styles: [".menu-extra-wrapper{position:relative}.menu-extra-content{margin:0 15px 15px 0}.menu-extra-popup{position:absolute;right:0;top:18px;padding:15px 0 0 15px;border:1px solid var(--theme-accent-500);width:max-content;z-index:9999;border-radius:15px 0 15px 15px;background-color:#fff;transform-origin:right top;transition:transform .25s ease-out;animation:slide-menu-in forwards .25s}@keyframes slide-menu-in{0%{transform:scale(0)}80%{transform:scale(1.05)}to{transform:scale(1)}}.menu-extra-popup button{margin-bottom:15px}.menu-extra-popup-extended{width:50vw}\n"],
      encapsulation: 2
    });
  }
  return MenuExtra;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NavSecondaryList = /*#__PURE__*/(() => {
  class NavSecondaryList {
    nav = [];
    constructor() {}
    ngOnInit() {}
    static ɵfac = function NavSecondaryList_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NavSecondaryList)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NavSecondaryList,
      selectors: [["su-nav-list"]],
      inputs: {
        nav: "nav"
      },
      standalone: false,
      decls: 2,
      vars: 1,
      consts: [["data-ui", "nav-secondary-list", 1, "nav-secondary-list"], [4, "ngFor", "ngForOf"], ["target", "_blank", 3, "href"]],
      template: function NavSecondaryList_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "ul", 0);
          i0.ɵɵtemplate(1, NavSecondaryList_li_1_Template, 3, 2, "li", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.nav);
        }
      },
      dependencies: [i1$1.NgForOf],
      styles: [".nav-secondary-list[_ngcontent-%COMP%]{font-size:12px;line-height:2}.nav-secondary-list[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:var(--theme-accent-500);text-decoration:none}.nav-secondary-list[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:focus, .nav-secondary-list[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:focus-visible, .nav-secondary-list[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{text-decoration:underline;outline:none;border:none}"]
    });
  }
  return NavSecondaryList;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SideNav = /*#__PURE__*/(() => {
  class SideNav {
    nav = [];
    selected;
    isOpen;
    static ɵfac = function SideNav_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SideNav)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SideNav,
      selectors: [["su-side-nav"]],
      inputs: {
        nav: "nav",
        selected: "selected",
        isOpen: "isOpen"
      },
      standalone: false,
      decls: 2,
      vars: 4,
      consts: [["data-ui", "side-nav", 1, "side-nav_container", 3, "ngClass"], [4, "ngFor", "ngForOf"], [1, "nav-block"], ["aria-hidden", "true", 1, "nav-label"], [1, "nav-items"], [3, "ngClass", "click", 4, "ngFor", "ngForOf"], [3, "click", "ngClass"], [3, "icon", 4, "ngIf"], [3, "icon"]],
      template: function SideNav_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, SideNav_ng_container_1_Template, 5, 2, "ng-container", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c7, !ctx.isOpen));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.nav);
        }
      },
      dependencies: [i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf, Icon],
      styles: [".side-nav_container[_ngcontent-%COMP%]{width:100%;padding:0;margin:0}.side-nav_container[_ngcontent-%COMP%]   .nav-block[_ngcontent-%COMP%] + .nav-block[_ngcontent-%COMP%]{margin-top:20px}.side-nav_container[_ngcontent-%COMP%]   .nav-label[_ngcontent-%COMP%]{font-weight:700;font-size:14px;line-height:1.3;color:#262626;margin-left:14px}.side-nav_container[_ngcontent-%COMP%]   .nav-label[_ngcontent-%COMP%]:before{content:attr(data-content)}.side-nav_container[_ngcontent-%COMP%]   .nav-label[_ngcontent-%COMP%] + .nav-items[_ngcontent-%COMP%]{margin-top:7px}.side-nav_container[_ngcontent-%COMP%]   .nav-items[_ngcontent-%COMP%]{margin:0 0 3px}.side-nav_container[_ngcontent-%COMP%]   .nav-items[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background-color:transparent;font-weight:400;font-size:var(--fs-bl);line-height:24px;color:#262626;text-align:left;display:flex;cursor:pointer;padding:7px 14px;width:100%;border-radius:30px;border:1px solid transparent;transition:background-color .3s ease-out,color .3s ease-out,border .3s ease-out,box-shadow .3s ease-out}.side-nav_container[_ngcontent-%COMP%]   .nav-items[_ngcontent-%COMP%]   button.selected[_ngcontent-%COMP%]{box-shadow:0 0 0 1px var(--theme-primary-500);color:var(--theme-primary-500)}.side-nav_container[_ngcontent-%COMP%]   .nav-items[_ngcontent-%COMP%]   button.selected[_ngcontent-%COMP%]:hover{box-shadow:0 0 0 2px var(--theme-primary-500)}.side-nav_container[_ngcontent-%COMP%]   .nav-items[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover{color:var(--theme-primary-500);background-color:color-mix(in srgb,var(--theme-primary-500) 5%,transparent)}.side-nav_container[_ngcontent-%COMP%]   .nav-items[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus-visible{outline:none;box-shadow:0 0 0 2px var(--theme-primary-500)}.side-nav_container[_ngcontent-%COMP%]   .nav-items[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   su-icon[_ngcontent-%COMP%]{width:var(--fs-bl);height:var(--fs-bl);color:var(--theme-primary-500);font-size:var(--fs-bl)}.side-nav_container[_ngcontent-%COMP%]   .nav-items[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   su-icon[_ngcontent-%COMP%] + span[_ngcontent-%COMP%]{margin-left:5px}.side-nav_container.isCollapsed[_ngcontent-%COMP%]   .nav-label[_ngcontent-%COMP%]{border-top:1px solid #dbdbdb;margin:15px 0}.side-nav_container.isCollapsed[_ngcontent-%COMP%]   .nav-label[_ngcontent-%COMP%]:before{content:\"\"}.side-nav_container.isCollapsed[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:none}.side-nav_container.isCollapsed[_ngcontent-%COMP%]   su-icon[_ngcontent-%COMP%]{width:var(--fs-bl-M-1);height:var(--fs-bl-M-1);color:#666!important;font-size:var(--fs-bl-M-1)!important;margin:0;text-align:center;line-height:.4}.side-nav_container.isCollapsed[_ngcontent-%COMP%]   .nav-items[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{justify-content:center}.side-nav_container.isCollapsed[_ngcontent-%COMP%]   .nav-items[_ngcontent-%COMP%]   button.selected[_ngcontent-%COMP%]{color:var(--theme-primary-500)}.side-nav_container.isCollapsed[_ngcontent-%COMP%]   .nav-items[_ngcontent-%COMP%]   button.selected[_ngcontent-%COMP%]   su-icon[_ngcontent-%COMP%]{line-height:.4;color:var(--theme-primary-500)!important}.side-nav_container.isCollapsed[_ngcontent-%COMP%]   .nav-items[_ngcontent-%COMP%]   button.selected[_ngcontent-%COMP%]:hover{box-shadow:0 0 0 2px var(--theme-primary-500)}.side-nav_container.isCollapsed[_ngcontent-%COMP%]   .nav-items[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover   su-icon[_ngcontent-%COMP%]{color:var(--theme-primary-500)!important}.side-nav_container.isCollapsed[_ngcontent-%COMP%]   .nav-items[_ngcontent-%COMP%]{padding:0 7.5px}"]
    });
  }
  return SideNav;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SlotControls = /*#__PURE__*/(() => {
  class SlotControls {
    dialog;
    mainTLabel;
    modal;
    dialogData;
    chips = [];
    buttons = [];
    menuItems = [];
    onRemoveChip = new EventEmitter();
    onCloseDialog = new EventEmitter();
    openDialog() {
      const dialogRef = this.dialog.open(this.modal, {
        data: this.dialogData,
        panelClass: 'dialog-panel-container'
      });
      dialogRef.afterClosed().subscribe({
        next: result => {
          this.handleOnCloseDialog();
        }
      });
    }
    constructor(dialog) {
      this.dialog = dialog;
    }
    handleOnRemoveChip() {
      this.onRemoveChip.emit();
    }
    handleOnCloseDialog() {
      this.onCloseDialog.emit();
    }
    static ɵfac = function SlotControls_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SlotControls)(i0.ɵɵdirectiveInject(i1$3.MatDialog));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SlotControls,
      selectors: [["su-slot-controls"]],
      inputs: {
        mainTLabel: "mainTLabel",
        modal: "modal",
        dialogData: "dialogData",
        chips: "chips",
        buttons: "buttons",
        menuItems: "menuItems"
      },
      outputs: {
        onRemoveChip: "onRemoveChip",
        onCloseDialog: "onCloseDialog"
      },
      standalone: false,
      decls: 7,
      vars: 3,
      consts: [["data-ui", "slot-controls", 1, "slot-controls"], [1, "row-action"], [1, "col-main-action"], ["icon", "filter", "skin", "tertiary", 3, "onClick", "label"], [1, "col-extra-actions"], [4, "ngIf"], ["skin", "tertiary", 3, "icon", "label", "disabled", "onClick", 4, "ngFor", "ngForOf"], ["skin", "tertiary", 3, "onClick", "icon", "label", "disabled"], ["icon", "ellipsis", 3, "menuItems"]],
      template: function SlotControls_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "su-button", 3);
          i0.ɵɵlistener("onClick", function SlotControls_Template_su_button_onClick_3_listener() {
            return ctx.openDialog();
          });
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(4, "div", 4);
          i0.ɵɵtemplate(5, SlotControls_ng_container_5_Template, 2, 1, "ng-container", 5)(6, SlotControls_ng_container_6_Template, 2, 1, "ng-container", 5);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵpropertyInterpolate("label", ctx.mainTLabel);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.buttons && ctx.buttons.length > 0);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.menuItems && ctx.menuItems.length > 0);
        }
      },
      dependencies: [i1$1.NgForOf, i1$1.NgIf, Button, MenuExtra],
      styles: [".su-dialog-panel-container{width:100%;height:90%;max-width:100%!important;max-height:100%!important}@media (min-width: 1025px){.su-dialog-panel-container{width:60vw}}.slot-controls{margin:0;display:flex;flex-direction:column;width:100%}.row-chips{flex:1;margin:15px 0}.row-action{flex:1;display:flex;flex-direction:row}.col-main-action{flex:1}.col-main-action button span{font-size:var(--fs-bl);font-weight:700}.col-extra-actions{display:flex;margin-left:auto;gap:15px}\n"],
      encapsulation: 2
    });
  }
  return SlotControls;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SlotDialogContent = /*#__PURE__*/(() => {
  class SlotDialogContent {
    static ɵfac = function SlotDialogContent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SlotDialogContent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SlotDialogContent,
      selectors: [["su-slot-dialog-content"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 2,
      vars: 0,
      consts: [["mat-dialog-content", "", "data-ui", "slot-dialog-content"]],
      template: function SlotDialogContent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
      },
      dependencies: [i1$3.MatDialogContent],
      styles: ["[_nghost-%COMP%]{flex:1;display:flex;align-items:stretch}  .mat-mdc-dialog-content{height:100%;min-height:100%}  .mat-mdc-dialog-content::-webkit-scrollbar{width:4px;height:4px}  .mat-mdc-dialog-content::-webkit-scrollbar-track{box-shadow:#0003 1px 1px 5px inset}  .mat-mdc-dialog-content::-webkit-scrollbar-thumb{min-height:20px;background-color:#0003}  .mat-mdc-dialog-content::-webkit-scrollbar-corner{background:transparent}  .mat-mdc-dialog-content{scrollbar-width:thin;scrollbar-color:var(--theme-primary-500) #fafafa}  .mat-dialog-content{overflow-y:hidden!important}"]
    });
  }
  return SlotDialogContent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SlotDialogFooter = /*#__PURE__*/(() => {
  class SlotDialogFooter {
    footer;
    static ɵfac = function SlotDialogFooter_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SlotDialogFooter)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SlotDialogFooter,
      selectors: [["su-slot-dialog-footer"]],
      inputs: {
        footer: "footer"
      },
      standalone: false,
      decls: 4,
      vars: 3,
      consts: [["mat-dialog-actions", "", "data-ui", "slot-dialog-footer", 1, "modal-content_footer"], [4, "ngIf"], ["skin", "secondary", 3, "onClick", "label", "disabled"], ["skin", "accent", 3, "onClick", "label", "disabled"]],
      template: function SlotDialogFooter_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, SlotDialogFooter_ng_container_1_Template, 2, 2, "ng-container", 1)(2, SlotDialogFooter_ng_container_2_Template, 2, 2, "ng-container", 1)(3, SlotDialogFooter_ng_container_3_Template, 2, 2, "ng-container", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.footer.button3);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.footer.button2);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.footer.button1);
        }
      },
      dependencies: [i1$1.NgIf, i1$3.MatDialogActions, Button],
      styles: [".modal-content_footer[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;gap:15px}.modal-content_footer[_ngcontent-%COMP%]   su-button[_ngcontent-%COMP%]:nth-child(1){margin-right:auto}"]
    });
  }
  return SlotDialogFooter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SlotDialogTitle = /*#__PURE__*/(() => {
  class SlotDialogTitle {
    title = '';
    static ɵfac = function SlotDialogTitle_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SlotDialogTitle)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SlotDialogTitle,
      selectors: [["su-slot-dialog-title"]],
      inputs: {
        title: "title"
      },
      standalone: false,
      decls: 5,
      vars: 1,
      consts: [["data-ui", "slot-dialog-title", 1, "dialog-title"], ["mat-dialog-title", ""], ["aria-label", "close dialog", "mat-dialog-close", "", 1, "dialog-button-close"], ["icon", "xmark"]],
      template: function SlotDialogTitle_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "h1", 1);
          i0.ɵɵtext(2);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "button", 2);
          i0.ɵɵelement(4, "su-icon", 3);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        }
      },
      dependencies: [i1$3.MatDialogClose, i1$3.MatDialogTitle, Icon],
      styles: [".mat-mdc-dialog-container .mdc-dialog__title{padding:0;font-family:inherit;line-height:inherit;font-size:inherit}.dialog-title[_ngcontent-%COMP%]{display:flex;padding:10px 20px;align-items:center}.dialog-button-close[_ngcontent-%COMP%]{margin-left:auto;display:flex;flex-direction:column;padding:10px;justify-content:center;align-items:center;width:15px;height:15px;font-size:14px;border-radius:15px;background-color:#fff;color:var(--theme-accent-500);border:1px solid var(--theme-accent-500);outline:none;transition:transform .15s ease-out;cursor:pointer}.dialog-button-close[_ngcontent-%COMP%]   su-icon[_ngcontent-%COMP%]{margin-top:2px;margin-left:-1px}.dialog-button-close[_ngcontent-%COMP%]:hover{background-color:color-mix(in srgb,var(--theme-accent-500) 10%,transparent)}.dialog-button-close[_ngcontent-%COMP%]:hover, .dialog-button-close[_ngcontent-%COMP%]:focus-visible{transform:scale(1.1)}.dialog-button-close[_ngcontent-%COMP%]:focus-visible{outline:none;border-color:transparent;box-shadow:0 0 0 2px #000}.dialog-button-close[_ngcontent-%COMP%]:active{outline:none}"]
    });
  }
  return SlotDialogTitle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Wrapper for page content
 */
let SlotMain = /*#__PURE__*/(() => {
  class SlotMain {
    hasSideNav = true;
    isSideNavOpen = true;
    static ɵfac = function SlotMain_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SlotMain)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SlotMain,
      selectors: [["su-slot-main"]],
      inputs: {
        hasSideNav: "hasSideNav",
        isSideNavOpen: "isSideNavOpen"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 2,
      vars: 4,
      consts: [["data-ui", "slot-main", 3, "ngClass"]],
      template: function SlotMain_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "main", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c9, ctx.hasSideNav, ctx.isSideNavOpen && ctx.hasSideNav));
        }
      },
      dependencies: [i1$1.NgClass],
      styles: ["main[_ngcontent-%COMP%]{position:absolute;top:0;left:0;padding:0 15px 0 30px;min-height:100vh;width:100%;transition:margin-left .15s ease-out .05s,width .15s ease-out;background-color:#fff}@media screen and (max-width: 767px){main[_ngcontent-%COMP%]{padding:0 15px;margin-top:65px}}.hasSideNav[_ngcontent-%COMP%]{margin-left:60px;width:calc(100% - 60px)}@media screen and (max-width: 767px){.hasSideNav[_ngcontent-%COMP%]{margin-left:0;width:100%}}.isSideNavOpen[_ngcontent-%COMP%]{margin-left:300px;width:calc(100% - 300px)}@media screen and (max-width: 1023px){.isSideNavOpen[_ngcontent-%COMP%]{margin-left:60px;width:calc(100% - 60px)}}@media screen and (max-width: 767px){.isSideNavOpen[_ngcontent-%COMP%]{margin-left:0;width:100%}}"]
    });
  }
  return SlotMain;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SlotMobileTopBar = /*#__PURE__*/(() => {
  class SlotMobileTopBar {
    topBarBtns = [];
    userInfo = undefined;
    accountBtns = [];
    brandingLogoXs = '';
    brandingTitle = '';
    navItemsTree = [];
    metaNavItemsTree = [];
    activeNavItem = '';
    showSideNav = true;
    isOpen = false;
    onToggle = new EventEmitter();
    onLogoClick = new EventEmitter();
    handleToggleClick() {
      this.onToggle.emit();
    }
    handleLogoClick() {
      this.onLogoClick.emit();
    }
    static ɵfac = function SlotMobileTopBar_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SlotMobileTopBar)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SlotMobileTopBar,
      selectors: [["su-slot-mobile-top-bar"]],
      inputs: {
        topBarBtns: "topBarBtns",
        userInfo: "userInfo",
        accountBtns: "accountBtns",
        brandingLogoXs: "brandingLogoXs",
        brandingTitle: "brandingTitle",
        navItemsTree: "navItemsTree",
        metaNavItemsTree: "metaNavItemsTree",
        activeNavItem: "activeNavItem",
        showSideNav: "showSideNav",
        isOpen: "isOpen"
      },
      outputs: {
        onToggle: "onToggle",
        onLogoClick: "onLogoClick"
      },
      standalone: false,
      decls: 14,
      vars: 8,
      consts: [["data-ui", "slot-mobile-top-bar", 1, "slot-mobile-top-bar", "isMobile"], [1, "branding", 3, "click"], [1, "logo", 3, "src", "alt"], [1, "top-bar-menu"], [1, "top-bar-menu-btn"], ["icon", "bars", 3, "menuItems"], ["skin", "tertiary", "icon", "right-to-bracket", 4, "ngIf"], ["icon", "user", 3, "menuItems", 4, "ngIf"], ["skin", "secondary", "icon", "bars", 3, "onClick", 4, "ngIf"], ["class", "mobile-side-nav isMobile", 4, "ngIf"], ["role", "button", "class", "side-nav-mobile-bg", 3, "click", 4, "ngIf"], ["skin", "tertiary", "icon", "right-to-bracket"], ["icon", "user", 3, "menuItems"], ["skin", "secondary", "icon", "bars", 3, "onClick"], [1, "mobile-side-nav", "isMobile"], [1, "main-nav"], [3, "nav", "selected", "isOpen"], [1, "meta-nav"], [3, "nav"], ["role", "button", 1, "side-nav-mobile-bg", 3, "click"]],
      template: function SlotMobileTopBar_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
          i0.ɵɵlistener("click", function SlotMobileTopBar_Template_div_click_1_listener() {
            return ctx.handleLogoClick();
          });
          i0.ɵɵelement(2, "img", 2);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "div")(4, "div", 3)(5, "div", 4);
          i0.ɵɵelement(6, "su-menu-extra", 5);
          i0.ɵɵtemplate(7, SlotMobileTopBar_su_button_7_Template, 1, 0, "su-button", 6);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(8, "div", 4);
          i0.ɵɵtemplate(9, SlotMobileTopBar_su_menu_extra_9_Template, 1, 1, "su-menu-extra", 7);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(10, "div");
          i0.ɵɵtemplate(11, SlotMobileTopBar_su_button_11_Template, 1, 0, "su-button", 8);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(12, SlotMobileTopBar_div_12_Template, 5, 6, "div", 9)(13, SlotMobileTopBar_div_13_Template, 1, 0, "div", 10);
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵpropertyInterpolate("alt", ctx.brandingTitle);
          i0.ɵɵproperty("src", ctx.brandingLogoXs, i0.ɵɵsanitizeUrl);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("menuItems", ctx.topBarBtns);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.userInfo);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.userInfo);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.showSideNav);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.isOpen);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.isOpen);
        }
      },
      dependencies: [i1$1.NgIf, SideNav, Button, NavSecondaryList, MenuExtra],
      styles: [".slot-mobile-top-bar{position:fixed;top:0;left:0;width:100%;z-index:999;height:50px;padding:0 15px;align-items:center;justify-content:space-between;background-color:#fff;box-shadow:0 0 5px #0000001a}.branding img{max-height:15px;width:auto}.top-bar-menu{display:flex;align-items:center}.top-bar-menu-btn{margin-right:15px}.top-bar-menu-btn:last-of-type{margin-right:0}.mobile-side-nav{position:fixed;top:0;height:100%;height:100svh;background-color:#fff;box-shadow:0 0 5px #0000001a;z-index:998;overflow:auto;padding:65px 15px 15px;display:flex;flex-direction:column;justify-content:space-between;animation:move-in forwards .25s}@keyframes move-in{0%{right:-200px}80%{width:80vw}90%{width:85vw}to{right:0;width:80vw}}.mobile-side-nav .meta-nav{margin-top:30px;padding:0 15px}.side-nav-mobile-bg{display:none;position:fixed;top:0;left:0;z-index:997;width:100%;height:100%;background-color:#0009}@keyframes fade-in{0%{opacity:0}to{opacity:1}}@media screen and (max-width: 1023px){.side-nav-mobile-bg{display:none}}@media screen and (max-width: 767px){.side-nav-mobile-bg{display:block;animation:fade-in forwards .5s}}.isMobile{display:none}@media screen and (max-width: 767px){.isMobile{display:flex}}\n"],
      encapsulation: 2
    });
  }
  return SlotMobileTopBar;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SlotShortcuts = /*#__PURE__*/(() => {
  class SlotShortcuts {
    heading = undefined;
    links = [];
    cards = [];
    static ɵfac = function SlotShortcuts_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SlotShortcuts)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SlotShortcuts,
      selectors: [["su-slot-shortcuts"]],
      inputs: {
        heading: "heading",
        links: "links",
        cards: "cards"
      },
      standalone: false,
      decls: 4,
      vars: 3,
      consts: [["data-ui", "slot-shortcuts", 1, "slot-shortcuts"], ["skin", "tertiary", "h", "h2", 4, "ngIf"], ["class", "slot-shortcuts-content", 4, "ngIf"], ["skin", "tertiary", "h", "h2"], [1, "slot-shortcuts-content"], [3, "label", 4, "ngFor", "ngForOf"], [3, "label"], [3, "label", "icon", "onClick", 4, "ngFor", "ngForOf"], [3, "onClick", "label", "icon"], [3, "card", 4, "ngFor", "ngForOf"], [3, "card"], ["card-content", "", 4, "ngIf"], ["card-content", ""]],
      template: function SlotShortcuts_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, SlotShortcuts_su_headline_1_Template, 2, 1, "su-headline", 1)(2, SlotShortcuts_div_2_Template, 2, 1, "div", 2)(3, SlotShortcuts_div_3_Template, 2, 1, "div", 2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.heading);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.links && ctx.links.length > 0);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.cards && ctx.cards.length > 0);
        }
      },
      dependencies: [i1$1.NgForOf, i1$1.NgIf, LinkCard, BlockLinkCards, ContentCard, Headline],
      styles: [".slot-shortcuts[_ngcontent-%COMP%]{margin:30px 0}.slot-shortcuts-content[_ngcontent-%COMP%]{margin-top:30px}"]
    });
  }
  return SlotShortcuts;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SlotSideNav = /*#__PURE__*/(() => {
  class SlotSideNav {
    brandingLogoXl = '';
    brandingLogoXs = '';
    brandingTitle = '';
    activeNavItem = '';
    isOpen = true;
    navItemsTree = [];
    metaNavItemsTree = [];
    onToggle = new EventEmitter();
    onLogoClick = new EventEmitter();
    /**
     * @ignore
     */
    handleToggleClick() {
      this.onToggle.emit();
    }
    handleLogoClick() {
      this.onLogoClick.emit();
    }
    static ɵfac = function SlotSideNav_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SlotSideNav)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SlotSideNav,
      selectors: [["su-slot-side-nav"]],
      inputs: {
        brandingLogoXl: "brandingLogoXl",
        brandingLogoXs: "brandingLogoXs",
        brandingTitle: "brandingTitle",
        activeNavItem: "activeNavItem",
        isOpen: "isOpen",
        navItemsTree: "navItemsTree",
        metaNavItemsTree: "metaNavItemsTree"
      },
      outputs: {
        onToggle: "onToggle",
        onLogoClick: "onLogoClick"
      },
      standalone: false,
      decls: 11,
      vars: 13,
      consts: [["data-ui", "slot-side-nav", 1, "side-nav", 3, "ngClass"], [1, "branding", "slot", 3, "click"], [1, "logo", 3, "src", "alt"], [1, "slot"], [3, "onClick", "isOpen"], [1, "main-nav"], [3, "nav", "selected", "isOpen"], [1, "meta-nav", "slot"], [3, "nav"], ["role", "button", "class", "side-nav-bg", 3, "click", 4, "ngIf"], ["role", "button", 1, "side-nav-bg", 3, "click"]],
      template: function SlotSideNav_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div")(2, "div", 1);
          i0.ɵɵlistener("click", function SlotSideNav_Template_div_click_2_listener() {
            return ctx.handleLogoClick();
          });
          i0.ɵɵelement(3, "img", 2);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "div", 3)(5, "su-nav-collapse", 4);
          i0.ɵɵlistener("onClick", function SlotSideNav_Template_su_nav_collapse_onClick_5_listener() {
            return ctx.handleToggleClick();
          });
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(6, "div", 5);
          i0.ɵɵelement(7, "su-side-nav", 6);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(8, "div", 7);
          i0.ɵɵelement(9, "su-nav-list", 8);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(10, SlotSideNav_div_10_Template, 1, 0, "div", 9);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c11, ctx.isOpen));
          i0.ɵɵadvance(3);
          i0.ɵɵpropertyInterpolate("alt", ctx.brandingTitle);
          i0.ɵɵproperty("src", ctx.isOpen ? ctx.brandingLogoXl : ctx.brandingLogoXs, i0.ɵɵsanitizeUrl);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("isOpen", ctx.isOpen);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("nav", ctx.navItemsTree || i0.ɵɵpureFunction0(11, _c10))("selected", ctx.activeNavItem)("isOpen", ctx.isOpen);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("nav", ctx.metaNavItemsTree || i0.ɵɵpureFunction0(12, _c10));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.isOpen);
        }
      },
      dependencies: [i1$1.NgClass, i1$1.NgIf, SideNav, ButtonSideNavCollapse, NavSecondaryList],
      styles: [".slot[_ngcontent-%COMP%]{padding-top:15px;text-align:center;transition:text-align .25s ease-in-out}.side-nav[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:60px;padding:15px;height:100vh;transition:width .15s ease-in-out,padding .25s ease-in-out;box-shadow:inset -4px 0 5px #0000001a;background-color:#fafafa;display:flex;flex-direction:column;justify-content:space-between;overflow-x:hidden;overflow-y:auto!important;-ms-overflow-style:inherit;scrollbar-width:thin;scrollbar-color:var(--theme-primary-500) #fafafa;z-index:999}@media screen and (max-width: 767px){.side-nav[_ngcontent-%COMP%]{display:none}}.side-nav[_ngcontent-%COMP%]::-webkit-scrollbar{width:5px;display:initial!important}.side-nav[_ngcontent-%COMP%]::-webkit-scrollbar-track{background:#fafafa}.side-nav[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background-color:var(--theme-primary-500);border-radius:0;border:1px solid #fafafa}.side-nav[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{-ms-overflow-style:none;scrollbar-width:none}.side-nav[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]::-webkit-scrollbar{display:none}.side-nav.isOpen[_ngcontent-%COMP%]{width:300px;padding:15px 30px 15px 22.5px}.side-nav.isOpen[_ngcontent-%COMP%]   .slot[_ngcontent-%COMP%]{text-align:left}.side-nav.isOpen[_ngcontent-%COMP%]   .main-nav[_ngcontent-%COMP%]{margin:30px -15px}.side-nav.isOpen[_ngcontent-%COMP%]   .meta-nav[_ngcontent-%COMP%]{display:block}.main-nav[_ngcontent-%COMP%]{margin:15px -15px;flex:1}.meta-nav[_ngcontent-%COMP%]{display:none}.branding[_ngcontent-%COMP%]{width:100%;cursor:pointer}.branding[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:auto;height:auto;max-width:100%;max-height:35px}.side-nav-bg[_ngcontent-%COMP%]{display:none;position:fixed;top:0;left:0;z-index:998;width:100%;height:100%;background-color:#0009}@keyframes _ngcontent-%COMP%_fade-in{0%{opacity:0}to{opacity:1}}@media screen and (max-width: 1023px){.side-nav-bg[_ngcontent-%COMP%]{display:block;animation:_ngcontent-%COMP%_fade-in forwards .25s}}@media screen and (max-width: 767px){.side-nav-bg[_ngcontent-%COMP%]{display:none}}"]
    });
  }
  return SlotSideNav;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SlotSpacer = /*#__PURE__*/(() => {
  class SlotSpacer {
    static ɵfac = function SlotSpacer_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SlotSpacer)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SlotSpacer,
      selectors: [["su-slot-spacer"]],
      standalone: false,
      decls: 1,
      vars: 0,
      consts: [["data-ui", "slot-spacer", 1, "slot-spacer"]],
      template: function SlotSpacer_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", 0);
        }
      },
      styles: [".slot-spacer[_ngcontent-%COMP%]{margin:30px 0}"]
    });
  }
  return SlotSpacer;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SlotTabContent = /*#__PURE__*/(() => {
  class SlotTabContent {
    /**
     * @ignore
     */
    shouldAnimate = false;
    /**
     * @ignore
     */
    ngOnInit() {
      setTimeout(() => {
        this.shouldAnimate = true;
      }, 0);
    }
    static ɵfac = function SlotTabContent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SlotTabContent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SlotTabContent,
      selectors: [["su-slot-tab-content"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 2,
      vars: 3,
      consts: [["data-ui", "slot-tab-content", 1, "slot-tab-content", 3, "ngClass"]],
      template: function SlotTabContent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c12, ctx.shouldAnimate));
        }
      },
      dependencies: [i1$1.NgClass],
      styles: [".slot-tab-content[_ngcontent-%COMP%]{margin:22.5px 0 22.5px 15px;opacity:0;transition:margin-left .25s ease-out,opacity .5s ease-out}.slot-tab-content-slide-in[_ngcontent-%COMP%]{opacity:1;margin:22.5px 0}"]
    });
  }
  return SlotTabContent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Tabs = /*#__PURE__*/(() => {
  class Tabs {
    activeTab = undefined;
    tabs = [];
    static ɵfac = function Tabs_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || Tabs)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: Tabs,
      selectors: [["su-tabs"]],
      inputs: {
        activeTab: "activeTab",
        tabs: "tabs"
      },
      standalone: false,
      decls: 2,
      vars: 1,
      consts: [["data-ui", "tabs", 1, "tabs"], ["role", "tablist", 4, "ngFor", "ngForOf"], ["role", "tablist"], ["role", "tab", 3, "click", "disabled", "ngClass"], [3, "color", "icon", 4, "ngIf"], [3, "icon"]],
      template: function Tabs_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, Tabs_ng_container_1_Template, 5, 10, "ng-container", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.tabs);
        }
      },
      dependencies: [i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf, Icon],
      styles: ["su-tabs{width:100%;overflow:hidden;position:relative}su-tabs:after{content:\"\";position:absolute;pointer-events:none;top:0;right:-15px;height:100%;width:120px;background:#fff;background:linear-gradient(90deg,#fff0,#fff)}.tabs{padding-right:45px;padding-left:2px;display:flex;border-bottom:1px solid #f5f5f5;margin:15px 0;width:100%;overflow-y:hidden;overflow-x:auto!important;-ms-overflow-style:inherit;scrollbar-width:thin}.tabs::-webkit-scrollbar{width:0;height:0;display:initial!important}.tabs::-webkit-scrollbar-track{background:#fafafa}.tabs::-webkit-scrollbar-thumb{border:none}.tabs *{-ms-overflow-style:none;scrollbar-width:none}.tabs *::-webkit-scrollbar{display:none}.tabs button{font-weight:700;border:none;font-size:var(--fs-bl);background-color:transparent;color:#000;text-align:left;display:flex;cursor:pointer;padding:7.5px 15px;width:100%;transition:background-color .3s ease-out,box-shadow .3s ease-out,color .3s ease-out}.tabs button:hover:not(:disabled),.tabs button:hover:not([disabled]){color:var(--theme-primary-500);background-color:color-mix(in srgb,var(--theme-primary-500) 5%,transparent)}.tabs button:focus-visible{outline:transparent;color:var(--theme-primary-500);text-decoration:underline;box-shadow:0 0 0 2px var(--theme-primary-500)}.tabs button.selected{color:var(--theme-primary-500);position:relative}.tabs button.selected:after{content:\"\";position:absolute;bottom:0;left:0;height:2px;animation:slide-in forwards .25s;background-color:var(--theme-primary-500)}@keyframes slide-in{0%{width:0}to{width:100%}}.tabs button:disabled,.tabs button[disabled]{color:#9f9f9f;cursor:default}.tabs button su-icon{margin-left:7.5px}\n"],
      encapsulation: 2
    });
  }
  return Tabs;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SlotTabs = /*#__PURE__*/(() => {
  class SlotTabs {
    tabs = [];
    activeTab = undefined;
    static ɵfac = function SlotTabs_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SlotTabs)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SlotTabs,
      selectors: [["su-slot-tabs"]],
      inputs: {
        tabs: "tabs",
        activeTab: "activeTab"
      },
      standalone: false,
      decls: 2,
      vars: 2,
      consts: [["data-ui", "slot-tabs", 1, "slot-tabs"], [3, "tabs", "activeTab"]],
      template: function SlotTabs_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵelement(1, "su-tabs", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("tabs", ctx.tabs)("activeTab", ctx.activeTab);
        }
      },
      dependencies: [Tabs],
      styles: [".slot-tabs[_ngcontent-%COMP%]{margin:15px 0;width:100%}"]
    });
  }
  return SlotTabs;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SlotTitle = /*#__PURE__*/(() => {
  class SlotTitle {
    title = '';
    static ɵfac = function SlotTitle_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SlotTitle)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SlotTitle,
      selectors: [["su-slot-title"]],
      inputs: {
        title: "title"
      },
      standalone: false,
      decls: 3,
      vars: 1,
      consts: [["data-ui", "slot-title", 1, "slot-title"], ["h", "h1", "skin", "primary"]],
      template: function SlotTitle_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "su-headline", 1);
          i0.ɵɵtext(2);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.title);
        }
      },
      dependencies: [Headline],
      styles: [".slot-title[_ngcontent-%COMP%]{margin:30px 0}"]
    });
  }
  return SlotTitle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SlotTopBar = /*#__PURE__*/(() => {
  class SlotTopBar {
    breadcrumbs = [];
    topBarBtns = [];
    userInfo = undefined;
    accountBtns = [];
    onBackBtnClick = new EventEmitter();
    onHomeBtnClick = new EventEmitter();
    onLoginClick = new EventEmitter();
    /**
     * @ignore
     */
    handleLoginClick() {
      this.onLoginClick.emit();
    }
    handleBackBtnClick() {
      this.onBackBtnClick.emit();
    }
    /**
     * @ignore
     */
    handleHomeBtnClick() {
      this.onHomeBtnClick.emit();
    }
    static ɵfac = function SlotTopBar_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SlotTopBar)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SlotTopBar,
      selectors: [["su-slot-top-bar"]],
      inputs: {
        breadcrumbs: "breadcrumbs",
        topBarBtns: "topBarBtns",
        userInfo: "userInfo",
        accountBtns: "accountBtns"
      },
      outputs: {
        onBackBtnClick: "onBackBtnClick",
        onHomeBtnClick: "onHomeBtnClick",
        onLoginClick: "onLoginClick"
      },
      standalone: false,
      decls: 16,
      vars: 7,
      consts: [["data-ui", "slot-top-bar", 1, "slot-top-bar"], [1, "slot-top-bar-left"], [3, "slots", "onBackBtnClick", "onHomeBtnClick", 4, "ngIf"], [1, "slot-top-bar-right"], [1, "isDesktop"], [1, "slot-top-bar-actions"], ["skin", "tertiary", 3, "label", "icon", "disabled", "onClick", 4, "ngFor", "ngForOf"], [1, "isTablet"], ["icon", "bars", 3, "menuItems"], [1, "slot-top-bar-account"], ["label", "Anmelden", "skin", "tertiary", "icon", "right-to-bracket", 3, "onClick", 4, "ngIf"], ["icon", "user", 3, "label", "menuItems", 4, "ngIf"], ["skin", "tertiary", "icon", "right-to-bracket", 3, "onClick", 4, "ngIf"], ["icon", "user", 3, "menuItems", 4, "ngIf"], [3, "onBackBtnClick", "onHomeBtnClick", "slots"], ["skin", "tertiary", 3, "onClick", "label", "icon", "disabled"], ["label", "Anmelden", "skin", "tertiary", "icon", "right-to-bracket", 3, "onClick"], ["icon", "user", 3, "label", "menuItems"], ["skin", "tertiary", "icon", "right-to-bracket", 3, "onClick"], ["icon", "user", 3, "menuItems"]],
      template: function SlotTopBar_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
          i0.ɵɵtemplate(2, SlotTopBar_su_breadcrumbs_2_Template, 1, 1, "su-breadcrumbs", 2);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "div", 3)(4, "div", 4)(5, "div", 5);
          i0.ɵɵtemplate(6, SlotTopBar_su_button_6_Template, 1, 3, "su-button", 6);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(7, "div", 7);
          i0.ɵɵelement(8, "su-menu-extra", 8);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(9, "div", 9)(10, "div", 4);
          i0.ɵɵtemplate(11, SlotTopBar_su_button_11_Template, 1, 0, "su-button", 10)(12, SlotTopBar_su_menu_extra_12_Template, 1, 2, "su-menu-extra", 11);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(13, "div", 7);
          i0.ɵɵtemplate(14, SlotTopBar_su_button_14_Template, 1, 0, "su-button", 12)(15, SlotTopBar_su_menu_extra_15_Template, 1, 1, "su-menu-extra", 13);
          i0.ɵɵelementEnd()()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.breadcrumbs.length > 0);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("ngForOf", ctx.topBarBtns);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("menuItems", ctx.topBarBtns);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", !ctx.userInfo);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.userInfo);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.userInfo);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.userInfo);
        }
      },
      dependencies: [i1$1.NgForOf, i1$1.NgIf, Breadcrumbs, Button, MenuExtra],
      styles: [".slot-top-bar{margin:15px 15px 30px 0;width:100%;display:flex;justify-content:space-between;font-size:var(--fs-bl-m-1)}.slot-top-bar-right{display:flex}@media screen and (max-width: 1023px){.isDesktop{display:none}}.isTablet{display:none}@media screen and (max-width: 1023px){.isTablet{display:block}}@media screen and (max-width: 767px){.isTablet{display:none}}.slot-top-bar-account{display:flex}.slot-top-bar-actions{display:flex;gap:15px}.slot-top-bar-actions su-button{margin:0 7.5px}.slot-top-bar-actions su-button:last-of-type{margin:0}.slot-top-bar-actions:after{content:\"|\";color:#bfbfbf;margin:0 15px 0 0}.menu-extra_menu{border:1px solid var(--theme-accent-500);box-shadow:none;border-top-right-radius:0!important}\n"],
      encapsulation: 2
    });
  }
  return SlotTopBar;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Table = /*#__PURE__*/(() => {
  class Table {
    static ɵfac = function Table_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || Table)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: Table,
      selectors: [["su-table"]],
      standalone: false,
      decls: 699,
      vars: 0,
      consts: [[1, "table"], [1, "table-wrapper"]],
      template: function Table_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "table")(3, "tr")(4, "td");
          i0.ɵɵtext(5, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "td");
          i0.ɵɵtext(7, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(8, "td");
          i0.ɵɵtext(9, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(10, "td");
          i0.ɵɵtext(11, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(12, "td");
          i0.ɵɵtext(13, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(14, "td");
          i0.ɵɵtext(15, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(16, "td");
          i0.ɵɵtext(17, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(18, "td");
          i0.ɵɵtext(19, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(20, "td");
          i0.ɵɵtext(21, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(22, "td");
          i0.ɵɵtext(23, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(24, "td");
          i0.ɵɵtext(25, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(26, "td");
          i0.ɵɵtext(27, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(28, "td");
          i0.ɵɵtext(29, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(30, "td");
          i0.ɵɵtext(31, "Lorem Ipsum");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(32, "tr")(33, "td");
          i0.ɵɵtext(34, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(35, "td");
          i0.ɵɵtext(36, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(37, "td");
          i0.ɵɵtext(38, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(39, "td");
          i0.ɵɵtext(40, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(41, "td");
          i0.ɵɵtext(42, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(43, "td");
          i0.ɵɵtext(44, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(45, "td");
          i0.ɵɵtext(46, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(47, "td");
          i0.ɵɵtext(48, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(49, "td");
          i0.ɵɵtext(50, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(51, "td");
          i0.ɵɵtext(52, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(53, "td");
          i0.ɵɵtext(54, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(55, "td");
          i0.ɵɵtext(56, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(57, "td");
          i0.ɵɵtext(58, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(59, "td");
          i0.ɵɵtext(60, "Lorem Ipsum");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(61, "tr")(62, "td");
          i0.ɵɵtext(63, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(64, "td");
          i0.ɵɵtext(65, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(66, "td");
          i0.ɵɵtext(67, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(68, "td");
          i0.ɵɵtext(69, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(70, "td");
          i0.ɵɵtext(71, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(72, "td");
          i0.ɵɵtext(73, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(74, "td");
          i0.ɵɵtext(75, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(76, "td");
          i0.ɵɵtext(77, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(78, "td");
          i0.ɵɵtext(79, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(80, "td");
          i0.ɵɵtext(81, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(82, "td");
          i0.ɵɵtext(83, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(84, "td");
          i0.ɵɵtext(85, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(86, "td");
          i0.ɵɵtext(87, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(88, "td");
          i0.ɵɵtext(89, "Lorem Ipsum");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(90, "tr")(91, "td");
          i0.ɵɵtext(92, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(93, "td");
          i0.ɵɵtext(94, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(95, "td");
          i0.ɵɵtext(96, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(97, "td");
          i0.ɵɵtext(98, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(99, "td");
          i0.ɵɵtext(100, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(101, "td");
          i0.ɵɵtext(102, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(103, "td");
          i0.ɵɵtext(104, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(105, "td");
          i0.ɵɵtext(106, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(107, "td");
          i0.ɵɵtext(108, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(109, "td");
          i0.ɵɵtext(110, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(111, "td");
          i0.ɵɵtext(112, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(113, "td");
          i0.ɵɵtext(114, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(115, "td");
          i0.ɵɵtext(116, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(117, "td");
          i0.ɵɵtext(118, "Lorem Ipsum");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(119, "tr")(120, "td");
          i0.ɵɵtext(121, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(122, "td");
          i0.ɵɵtext(123, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(124, "td");
          i0.ɵɵtext(125, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(126, "td");
          i0.ɵɵtext(127, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(128, "td");
          i0.ɵɵtext(129, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(130, "td");
          i0.ɵɵtext(131, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(132, "td");
          i0.ɵɵtext(133, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(134, "td");
          i0.ɵɵtext(135, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(136, "td");
          i0.ɵɵtext(137, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(138, "td");
          i0.ɵɵtext(139, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(140, "td");
          i0.ɵɵtext(141, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(142, "td");
          i0.ɵɵtext(143, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(144, "td");
          i0.ɵɵtext(145, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(146, "td");
          i0.ɵɵtext(147, "Lorem Ipsum");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(148, "tr")(149, "td");
          i0.ɵɵtext(150, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(151, "td");
          i0.ɵɵtext(152, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(153, "td");
          i0.ɵɵtext(154, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(155, "td");
          i0.ɵɵtext(156, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(157, "td");
          i0.ɵɵtext(158, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(159, "td");
          i0.ɵɵtext(160, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(161, "td");
          i0.ɵɵtext(162, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(163, "td");
          i0.ɵɵtext(164, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(165, "td");
          i0.ɵɵtext(166, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(167, "td");
          i0.ɵɵtext(168, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(169, "td");
          i0.ɵɵtext(170, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(171, "td");
          i0.ɵɵtext(172, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(173, "td");
          i0.ɵɵtext(174, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(175, "td");
          i0.ɵɵtext(176, "Lorem Ipsum");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(177, "tr")(178, "td");
          i0.ɵɵtext(179, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(180, "td");
          i0.ɵɵtext(181, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(182, "td");
          i0.ɵɵtext(183, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(184, "td");
          i0.ɵɵtext(185, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(186, "td");
          i0.ɵɵtext(187, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(188, "td");
          i0.ɵɵtext(189, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(190, "td");
          i0.ɵɵtext(191, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(192, "td");
          i0.ɵɵtext(193, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(194, "td");
          i0.ɵɵtext(195, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(196, "td");
          i0.ɵɵtext(197, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(198, "td");
          i0.ɵɵtext(199, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(200, "td");
          i0.ɵɵtext(201, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(202, "td");
          i0.ɵɵtext(203, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(204, "td");
          i0.ɵɵtext(205, "Lorem Ipsum");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(206, "tr")(207, "td");
          i0.ɵɵtext(208, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(209, "td");
          i0.ɵɵtext(210, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(211, "td");
          i0.ɵɵtext(212, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(213, "td");
          i0.ɵɵtext(214, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(215, "td");
          i0.ɵɵtext(216, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(217, "td");
          i0.ɵɵtext(218, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(219, "td");
          i0.ɵɵtext(220, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(221, "td");
          i0.ɵɵtext(222, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(223, "td");
          i0.ɵɵtext(224, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(225, "td");
          i0.ɵɵtext(226, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(227, "td");
          i0.ɵɵtext(228, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(229, "td");
          i0.ɵɵtext(230, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(231, "td");
          i0.ɵɵtext(232, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(233, "td");
          i0.ɵɵtext(234, "Lorem Ipsum");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(235, "tr")(236, "td");
          i0.ɵɵtext(237, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(238, "td");
          i0.ɵɵtext(239, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(240, "td");
          i0.ɵɵtext(241, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(242, "td");
          i0.ɵɵtext(243, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(244, "td");
          i0.ɵɵtext(245, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(246, "td");
          i0.ɵɵtext(247, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(248, "td");
          i0.ɵɵtext(249, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(250, "td");
          i0.ɵɵtext(251, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(252, "td");
          i0.ɵɵtext(253, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(254, "td");
          i0.ɵɵtext(255, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(256, "td");
          i0.ɵɵtext(257, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(258, "td");
          i0.ɵɵtext(259, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(260, "td");
          i0.ɵɵtext(261, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(262, "td");
          i0.ɵɵtext(263, "Lorem Ipsum");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(264, "tr")(265, "td");
          i0.ɵɵtext(266, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(267, "td");
          i0.ɵɵtext(268, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(269, "td");
          i0.ɵɵtext(270, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(271, "td");
          i0.ɵɵtext(272, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(273, "td");
          i0.ɵɵtext(274, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(275, "td");
          i0.ɵɵtext(276, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(277, "td");
          i0.ɵɵtext(278, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(279, "td");
          i0.ɵɵtext(280, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(281, "td");
          i0.ɵɵtext(282, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(283, "td");
          i0.ɵɵtext(284, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(285, "td");
          i0.ɵɵtext(286, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(287, "td");
          i0.ɵɵtext(288, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(289, "td");
          i0.ɵɵtext(290, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(291, "td");
          i0.ɵɵtext(292, "Lorem Ipsum");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(293, "tr")(294, "td");
          i0.ɵɵtext(295, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(296, "td");
          i0.ɵɵtext(297, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(298, "td");
          i0.ɵɵtext(299, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(300, "td");
          i0.ɵɵtext(301, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(302, "td");
          i0.ɵɵtext(303, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(304, "td");
          i0.ɵɵtext(305, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(306, "td");
          i0.ɵɵtext(307, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(308, "td");
          i0.ɵɵtext(309, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(310, "td");
          i0.ɵɵtext(311, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(312, "td");
          i0.ɵɵtext(313, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(314, "td");
          i0.ɵɵtext(315, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(316, "td");
          i0.ɵɵtext(317, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(318, "td");
          i0.ɵɵtext(319, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(320, "td");
          i0.ɵɵtext(321, "Lorem Ipsum");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(322, "tr")(323, "td");
          i0.ɵɵtext(324, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(325, "td");
          i0.ɵɵtext(326, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(327, "td");
          i0.ɵɵtext(328, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(329, "td");
          i0.ɵɵtext(330, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(331, "td");
          i0.ɵɵtext(332, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(333, "td");
          i0.ɵɵtext(334, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(335, "td");
          i0.ɵɵtext(336, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(337, "td");
          i0.ɵɵtext(338, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(339, "td");
          i0.ɵɵtext(340, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(341, "td");
          i0.ɵɵtext(342, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(343, "td");
          i0.ɵɵtext(344, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(345, "td");
          i0.ɵɵtext(346, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(347, "td");
          i0.ɵɵtext(348, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(349, "td");
          i0.ɵɵtext(350, "Lorem Ipsum");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(351, "tr")(352, "td");
          i0.ɵɵtext(353, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(354, "td");
          i0.ɵɵtext(355, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(356, "td");
          i0.ɵɵtext(357, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(358, "td");
          i0.ɵɵtext(359, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(360, "td");
          i0.ɵɵtext(361, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(362, "td");
          i0.ɵɵtext(363, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(364, "td");
          i0.ɵɵtext(365, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(366, "td");
          i0.ɵɵtext(367, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(368, "td");
          i0.ɵɵtext(369, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(370, "td");
          i0.ɵɵtext(371, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(372, "td");
          i0.ɵɵtext(373, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(374, "td");
          i0.ɵɵtext(375, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(376, "td");
          i0.ɵɵtext(377, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(378, "td");
          i0.ɵɵtext(379, "Lorem Ipsum");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(380, "tr")(381, "td");
          i0.ɵɵtext(382, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(383, "td");
          i0.ɵɵtext(384, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(385, "td");
          i0.ɵɵtext(386, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(387, "td");
          i0.ɵɵtext(388, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(389, "td");
          i0.ɵɵtext(390, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(391, "td");
          i0.ɵɵtext(392, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(393, "td");
          i0.ɵɵtext(394, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(395, "td");
          i0.ɵɵtext(396, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(397, "td");
          i0.ɵɵtext(398, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(399, "td");
          i0.ɵɵtext(400, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(401, "td");
          i0.ɵɵtext(402, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(403, "td");
          i0.ɵɵtext(404, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(405, "td");
          i0.ɵɵtext(406, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(407, "td");
          i0.ɵɵtext(408, "Lorem Ipsum");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(409, "tr")(410, "td");
          i0.ɵɵtext(411, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(412, "td");
          i0.ɵɵtext(413, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(414, "td");
          i0.ɵɵtext(415, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(416, "td");
          i0.ɵɵtext(417, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(418, "td");
          i0.ɵɵtext(419, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(420, "td");
          i0.ɵɵtext(421, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(422, "td");
          i0.ɵɵtext(423, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(424, "td");
          i0.ɵɵtext(425, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(426, "td");
          i0.ɵɵtext(427, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(428, "td");
          i0.ɵɵtext(429, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(430, "td");
          i0.ɵɵtext(431, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(432, "td");
          i0.ɵɵtext(433, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(434, "td");
          i0.ɵɵtext(435, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(436, "td");
          i0.ɵɵtext(437, "Lorem Ipsum");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(438, "tr")(439, "td");
          i0.ɵɵtext(440, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(441, "td");
          i0.ɵɵtext(442, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(443, "td");
          i0.ɵɵtext(444, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(445, "td");
          i0.ɵɵtext(446, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(447, "td");
          i0.ɵɵtext(448, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(449, "td");
          i0.ɵɵtext(450, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(451, "td");
          i0.ɵɵtext(452, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(453, "td");
          i0.ɵɵtext(454, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(455, "td");
          i0.ɵɵtext(456, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(457, "td");
          i0.ɵɵtext(458, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(459, "td");
          i0.ɵɵtext(460, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(461, "td");
          i0.ɵɵtext(462, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(463, "td");
          i0.ɵɵtext(464, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(465, "td");
          i0.ɵɵtext(466, "Lorem Ipsum");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(467, "tr")(468, "td");
          i0.ɵɵtext(469, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(470, "td");
          i0.ɵɵtext(471, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(472, "td");
          i0.ɵɵtext(473, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(474, "td");
          i0.ɵɵtext(475, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(476, "td");
          i0.ɵɵtext(477, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(478, "td");
          i0.ɵɵtext(479, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(480, "td");
          i0.ɵɵtext(481, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(482, "td");
          i0.ɵɵtext(483, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(484, "td");
          i0.ɵɵtext(485, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(486, "td");
          i0.ɵɵtext(487, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(488, "td");
          i0.ɵɵtext(489, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(490, "td");
          i0.ɵɵtext(491, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(492, "td");
          i0.ɵɵtext(493, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(494, "td");
          i0.ɵɵtext(495, "Lorem Ipsum");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(496, "tr")(497, "td");
          i0.ɵɵtext(498, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(499, "td");
          i0.ɵɵtext(500, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(501, "td");
          i0.ɵɵtext(502, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(503, "td");
          i0.ɵɵtext(504, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(505, "td");
          i0.ɵɵtext(506, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(507, "td");
          i0.ɵɵtext(508, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(509, "td");
          i0.ɵɵtext(510, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(511, "td");
          i0.ɵɵtext(512, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(513, "td");
          i0.ɵɵtext(514, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(515, "td");
          i0.ɵɵtext(516, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(517, "td");
          i0.ɵɵtext(518, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(519, "td");
          i0.ɵɵtext(520, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(521, "td");
          i0.ɵɵtext(522, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(523, "td");
          i0.ɵɵtext(524, "Lorem Ipsum");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(525, "tr")(526, "td");
          i0.ɵɵtext(527, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(528, "td");
          i0.ɵɵtext(529, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(530, "td");
          i0.ɵɵtext(531, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(532, "td");
          i0.ɵɵtext(533, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(534, "td");
          i0.ɵɵtext(535, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(536, "td");
          i0.ɵɵtext(537, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(538, "td");
          i0.ɵɵtext(539, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(540, "td");
          i0.ɵɵtext(541, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(542, "td");
          i0.ɵɵtext(543, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(544, "td");
          i0.ɵɵtext(545, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(546, "td");
          i0.ɵɵtext(547, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(548, "td");
          i0.ɵɵtext(549, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(550, "td");
          i0.ɵɵtext(551, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(552, "td");
          i0.ɵɵtext(553, "Lorem Ipsum");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(554, "tr")(555, "td");
          i0.ɵɵtext(556, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(557, "td");
          i0.ɵɵtext(558, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(559, "td");
          i0.ɵɵtext(560, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(561, "td");
          i0.ɵɵtext(562, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(563, "td");
          i0.ɵɵtext(564, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(565, "td");
          i0.ɵɵtext(566, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(567, "td");
          i0.ɵɵtext(568, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(569, "td");
          i0.ɵɵtext(570, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(571, "td");
          i0.ɵɵtext(572, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(573, "td");
          i0.ɵɵtext(574, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(575, "td");
          i0.ɵɵtext(576, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(577, "td");
          i0.ɵɵtext(578, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(579, "td");
          i0.ɵɵtext(580, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(581, "td");
          i0.ɵɵtext(582, "Lorem Ipsum");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(583, "tr")(584, "td");
          i0.ɵɵtext(585, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(586, "td");
          i0.ɵɵtext(587, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(588, "td");
          i0.ɵɵtext(589, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(590, "td");
          i0.ɵɵtext(591, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(592, "td");
          i0.ɵɵtext(593, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(594, "td");
          i0.ɵɵtext(595, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(596, "td");
          i0.ɵɵtext(597, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(598, "td");
          i0.ɵɵtext(599, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(600, "td");
          i0.ɵɵtext(601, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(602, "td");
          i0.ɵɵtext(603, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(604, "td");
          i0.ɵɵtext(605, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(606, "td");
          i0.ɵɵtext(607, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(608, "td");
          i0.ɵɵtext(609, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(610, "td");
          i0.ɵɵtext(611, "Lorem Ipsum");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(612, "tr")(613, "td");
          i0.ɵɵtext(614, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(615, "td");
          i0.ɵɵtext(616, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(617, "td");
          i0.ɵɵtext(618, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(619, "td");
          i0.ɵɵtext(620, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(621, "td");
          i0.ɵɵtext(622, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(623, "td");
          i0.ɵɵtext(624, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(625, "td");
          i0.ɵɵtext(626, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(627, "td");
          i0.ɵɵtext(628, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(629, "td");
          i0.ɵɵtext(630, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(631, "td");
          i0.ɵɵtext(632, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(633, "td");
          i0.ɵɵtext(634, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(635, "td");
          i0.ɵɵtext(636, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(637, "td");
          i0.ɵɵtext(638, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(639, "td");
          i0.ɵɵtext(640, "Lorem Ipsum");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(641, "tr")(642, "td");
          i0.ɵɵtext(643, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(644, "td");
          i0.ɵɵtext(645, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(646, "td");
          i0.ɵɵtext(647, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(648, "td");
          i0.ɵɵtext(649, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(650, "td");
          i0.ɵɵtext(651, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(652, "td");
          i0.ɵɵtext(653, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(654, "td");
          i0.ɵɵtext(655, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(656, "td");
          i0.ɵɵtext(657, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(658, "td");
          i0.ɵɵtext(659, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(660, "td");
          i0.ɵɵtext(661, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(662, "td");
          i0.ɵɵtext(663, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(664, "td");
          i0.ɵɵtext(665, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(666, "td");
          i0.ɵɵtext(667, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(668, "td");
          i0.ɵɵtext(669, "Lorem Ipsum");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(670, "tr")(671, "td");
          i0.ɵɵtext(672, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(673, "td");
          i0.ɵɵtext(674, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(675, "td");
          i0.ɵɵtext(676, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(677, "td");
          i0.ɵɵtext(678, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(679, "td");
          i0.ɵɵtext(680, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(681, "td");
          i0.ɵɵtext(682, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(683, "td");
          i0.ɵɵtext(684, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(685, "td");
          i0.ɵɵtext(686, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(687, "td");
          i0.ɵɵtext(688, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(689, "td");
          i0.ɵɵtext(690, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(691, "td");
          i0.ɵɵtext(692, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(693, "td");
          i0.ɵɵtext(694, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(695, "td");
          i0.ɵɵtext(696, "Lorem Ipsum");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(697, "td");
          i0.ɵɵtext(698, "Lorem Ipsum");
          i0.ɵɵelementEnd()()()()();
        }
      },
      styles: [".table{width:100%;overflow:hidden}.table-wrapper{overflow-x:auto!important;overflow-y:auto!important;-ms-overflow-style:inherit;scrollbar-width:thin;scrollbar-color:var(--theme-primary-500) #fafafa;z-index:999}.table-wrapper::-webkit-scrollbar{height:5px;width:5px;display:initial!important}.table-wrapper::-webkit-scrollbar-track{background:#fafafa}.table-wrapper::-webkit-scrollbar-thumb{background-color:var(--theme-primary-500);border-radius:0;border:1px solid #fafafa}.table-wrapper *{-ms-overflow-style:none;scrollbar-width:none}.table-wrapper *::-webkit-scrollbar{display:none}table{width:2000px}td{border:1px solid black;padding:5px}\n"],
      encapsulation: 2
    });
  }
  return Table;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SmartusComponentsModule = /*#__PURE__*/(() => {
  class SmartusComponentsModule {
    constructor(library) {
      library.addIconPacks(fas, far);
    }
    static ɵfac = function SmartusComponentsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SmartusComponentsModule)(i0.ɵɵinject(i1.FaIconLibrary));
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SmartusComponentsModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FontAwesomeModule, MatMenuModule, MatDialogModule, MatTooltipModule]
    });
  }
  return SmartusComponentsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of smartus-components
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BlockLinkCards, Breadcrumbs, Button, ButtonSideNavCollapse, Chips, ContentCard, Headline, Icon, LinkCard, MenuExtra, NavSecondaryList, SideNav, SlotControls, SlotDialogContent, SlotDialogFooter, SlotDialogTitle, SlotMain, SlotMobileTopBar, SlotShortcuts, SlotSideNav, SlotSpacer, SlotTabContent, SlotTabs, SlotTitle, SlotTopBar, SmartusComponentsComponent, SmartusComponentsModule, SmartusComponentsService, Table, Tabs };
